import React, { useState, useRef, useEffect, useMemo } from "react";
import { toast } from 'react-toastify';
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/TaskScreenwebadmin.css"; // <-- your CSS path
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { IoChevronDown } from "react-icons/io5";
import close from "../assets/img/close-square.svg";

// API Services for real data - matching AdminTask.js
import taskService from '../../services/taskService';
import userService from '../../services/userService';
import propertyService from '../../services/propertyService';
import adminTaskService from '../../services/adminTaskService';
import adminStaffService from '../../services/adminStaffService';



// Keep your LeftNav / TopNav components (don't change)
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";

// Assets - adjust filenames/paths if needed
import calladm from "../assets/img/call-callingadmin.svg";
import IconFilter from "../assets/img/webadminfilter.svg";
import IconAdd from "../assets/img/webadduser.svg";
import adminclock from "../assets/img/adminclock.svg";
import calendar from "../assets/img/calendar.svg";



export default function TasksPage() {
  // Navigation hook
  const navigate = useNavigate();

  // Match AdminTask.js naming conventions
  const [activeTab, setActiveTab] = useState('Tasks');
  const [activeFilter, setActiveFilter] = useState('All');
  // Section expand/collapse + pagination: sections start collapsed, expanding shows
  // SECTION_PAGE_SIZE items and "Load More" reveals the next page
  const SECTION_PAGE_SIZE = 20;
  const [expandedSections, setExpandedSections] = useState({});
  const [sectionVisibleCounts, setSectionVisibleCounts] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({ ...prev, [sectionId]: !prev[sectionId] }));
    setSectionVisibleCounts(prev => ({ ...prev, [sectionId]: SECTION_PAGE_SIZE }));
  };

  const loadMoreSection = (sectionId) => {
    setSectionVisibleCounts(prev => ({ ...prev, [sectionId]: (prev[sectionId] || SECTION_PAGE_SIZE) + SECTION_PAGE_SIZE }));
  };

  // Collapsible sections + Load More apply to all tabs (Available, Backlog, Completed, Rejected)
  const collapsibleSections = true;
  const isSectionOpen = (sectionId) => !collapsibleSections || !!expandedSections[sectionId];

  // Collapse all sections when switching tabs
  useEffect(() => {
    setExpandedSections({});
    setSectionVisibleCounts({});
  }, [activeFilter]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [openPicker, setOpenPicker] = useState(null); // "filterStart" | "filterEnd" | "task"

  // API Data State - matching AdminTask.js
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [adminUsers, setAdminUsers] = useState([]); // Match AdminTask.js naming
  const [csStaffUsers, setCsStaffUsers] = useState([]); // CS staff only (for filter dropdown)
  const [freeStaff, setFreeStaff] = useState([]); // Staff with availability (for schedule modal)

  // Date filter states - MUST be declared early as they're used in functions
  const [fromDate1, setFromDate1] = useState('');
  const [toDate1, setToDate1] = useState('');

  // Dedicated Filter States - MUST be declared early (used in fetchTasks, getFilteredTasks, sections useMemo)
  const [filterTaskOwner, setFilterTaskOwner] = useState('');
  const [filterTaskType, setFilterTaskType] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  // Additional states for AdminTask.js compatibility (approval projects and welcome tasks) - MOVED TO TOP
  const [approvalProjects, setApprovalProjects] = useState([]);
  const [welcomeTasks, setWelcomeTasks] = useState({ active: [], missed: [], backlog: [], completed: [], counts: {} });
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [welcomeLoading, setWelcomeLoading] = useState(false);
  const [approvalStats, setApprovalStats] = useState({
    totalProjects: 0,
    pendingCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
  });

  // RERA Verification states (matching mobile app exactly)
  const [reraModalVisible, setReraModalVisible] = useState(false);
  const [reraModalTask, setReraModalTask] = useState(null);
  const [reraRejectReason, setReraRejectReason] = useState('');
  const [reraProcessing, setReraProcessing] = useState(false);

  // GST Verification states
  const [gstModalVisible, setGstModalVisible] = useState(false);
  const [gstModalTask, setGstModalTask] = useState(null);
  const [gstRejectReason, setGstRejectReason] = useState('');
  const [gstProcessing, setGstProcessing] = useState(false);

  // Project Verification states (matching mobile app exactly)
  const [selectedProject, setSelectedProject] = useState(null);
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const [actionLoading, setActionLoading] = useState(false);

  // Project Call Picker states (matching mobile app exactly)
  const [projectCallPickerVisible, setProjectCallPickerVisible] = useState(false);
  const [projectCallData, setProjectCallData] = useState(null);

  // Phone selection modal states (matching AdminTask.js mobile flow)
  const [phonePickerVisible, setPhonePickerVisible] = useState(false);
  const [pendingCallTask, setPendingCallTask] = useState(null);

  // Welcome Call states (matching mobile app exactly)
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [currentCallTask, setCurrentCallTask] = useState(null);

  // Schedule Follow-up Task states (matching mobile app exactly)
  const [scheduleModalVisible, setScheduleModalVisible] = useState(false);
  const [scheduleTaskName, setScheduleTaskName] = useState('');
  const [scheduleAssignedTo, setScheduleAssignedTo] = useState('');
  const [scheduleDate, setScheduleDate] = useState('');
  const [scheduleTime, setScheduleTime] = useState('');

  // Modal states for verification and issue details
  const [agentModalOpen, setAgentModalOpen] = useState(false);
  const [builderModalOpen, setBuilderModalOpen] = useState(false);
  const [issueModalOpen, setIssueModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  // Edit Modal States - matching AdminTask.js exactly
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editTaskName, setEditTaskName] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [editTaskType, setEditTaskType] = useState('');
  const [editPriority, setEditPriority] = useState('');
  const [editStatus, setEditStatus] = useState('');
  const [editAssignedTo, setEditAssignedTo] = useState('');
  const [editDueDate, setEditDueDate] = useState('');
  // const [editTaskOwner, setEditTaskOwner] = useState(''); // Unused for now

  // NEW: temporary picker state (only for Add Task modal date/time UI)
  const [pickerTmpDate, setPickerTmpDate] = useState({ day: "02", month: "Feb", year: "2021" });
  const [pickerTmpTime, setPickerTmpTime] = useState({ hour: "04", minute: "30", period: "PM" });

  // 📅 Custom Date Picker States
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
  const [currentDateType, setCurrentDateType] = useState("");
  const [selectedDayIdx, setSelectedDayIdx] = useState(0);
  const [selectedMonthIdx, setSelectedMonthIdx] = useState(0);
  const [selectedYearIdx, setSelectedYearIdx] = useState(0);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const startYear = 1950;
  const endYear = 2050;
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => (startYear + i).toString()
  );

  // Create fixed 31 days for simple loop
  const allDays = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString().padStart(2, "0")
  );


  // Use fixed 31 days for all months to enable smooth looping
  const days = allDays;

  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);

  const ITEM_HEIGHT = 40; // must match your CSS
  let scrollTimeout = null;

  // Load tasks and users from API
  // fetchTasks function matching AdminTask.js exactly
  const fetchTasks = async () => {
    try {
      setLoading(true);
      const filters = {};

      // Don't apply activeFilter status at API level - we filter on frontend
      // Apply filter modal selections only (use dedicated filter states - matching AdminTask.js)
      if (filterTaskOwner) filters.assigned_to = filterTaskOwner;
      if (filterTaskType) filters.category = filterTaskType;
      if (filterStatus) filters.status = filterStatus;

      // Default: Show last 7 days tasks if no date filters are applied
      const hasDateFilters = fromDate1 || toDate1;

      if (!hasDateFilters) {
        const today = new Date();
        const sevenDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7, 0, 0, 0);
        const endOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
        filters.created_date_from = sevenDaysAgo.toISOString();
        filters.created_date_to = endOfToday.toISOString();
      }

      // Convert date from "DD Month YYYY" to ISO format for API
      if (fromDate1) {
        try {
          const parts = fromDate1.split(' ');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'];
            const month = monthNames.indexOf(parts[1]);
            const year = parseInt(parts[2]);
            if (month !== -1) {
              const dateObj = new Date(year, month, day);
              filters.created_date_from = dateObj.toISOString();
            }
          }
        } catch (e) {
          console.error('Error parsing fromDate:', e);
        }
      }

      if (toDate1) {
        try {
          const parts = toDate1.split(' ');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'];
            const month = monthNames.indexOf(parts[1]);
            const year = parseInt(parts[2]);
            if (month !== -1) {
              const dateObj = new Date(year, month, day, 23, 59, 59);
              filters.created_date_to = dateObj.toISOString();
            }
          }
        } catch (e) {
          console.error('Error parsing toDate:', e);
        }
      }

      console.log('📋 Filters being sent to API:', filters);
      const response = await taskService.getTasks(filters);
      console.log('✅ Tasks fetched:', response);

      // Parse response based on API structure
      let tasksList = [];
      if (response.success && response.data) {
        tasksList = response.data.tasks || response.data || [];
      } else if (response.data) {
        tasksList = response.data.tasks || response.data || [];
      }

      setTasks(tasksList);
      console.log('Tasks set:', tasksList.length, 'tasks');

    } catch (error) {
      console.error('Error fetching tasks:', error);
      setTasks([]);
    } finally {
      setLoading(false);
    }
  };

  // fetchAdminUsers function matching AdminTask.js exactly
  const fetchAdminUsers = async () => {
    try {
      console.log('🔄 Starting fetchAdminUsers...');

      // Fetch all admin, manager, staff, and customer_support users in parallel (matching mobile app)
      const [adminResponse, managerResponse, subUserResponse, csStaffResponse] = await Promise.all([
        userService.getAllUsers({ role: 'admin' }),
        userService.getAllUsers({ role: 'manager' }),
        userService.getAllUsers({ role: 'sub_user' }),
        adminStaffService.getAllStaffStatus()
      ]);

      console.log('📊 User service responses:', {
        adminResponse: adminResponse?.success,
        managerResponse: managerResponse?.success,
        subUserResponse: subUserResponse?.success,
        csStaffResponse: csStaffResponse?.success
      });

      const seenIds = new Set();
      let allUsers = [];

      const addUsers = (users) => {
        for (const u of users) {
          if (!seenIds.has(u.id)) {
            seenIds.add(u.id);
            allUsers.push(u);
          }
        }
      };

      const getUserDisplayName = (user) => {
        // Try multiple possible name fields
        const possibleNames = [
          user.name,
          user.first_name,
          user.firstName,
          user.username,
          user.display_name,
          user.full_name,
          user.fullName
        ];

        const name = possibleNames.find(n => n && n.trim());
        console.log('🔍 User name extraction:', {
          user: user,
          foundName: name,
          fallbackEmail: user.email
        });

        return name || user.email?.split('@')[0] || user.email || 'Unknown User';
      };

      console.log('🔍 Raw response structures:', {
        adminResponse: adminResponse.data,
        managerResponse: managerResponse.data,
        subUserResponse: subUserResponse.data
      });

      console.log('🔍 Sample user data structure:', {
        sampleAdmin: adminResponse.data?.data?.users?.[0] || adminResponse.data?.users?.[0] || adminResponse.data?.[0],
        sampleManager: managerResponse.data?.data?.users?.[0] || managerResponse.data?.users?.[0] || managerResponse.data?.[0],
        sampleSubUser: subUserResponse.data?.data?.users?.[0] || subUserResponse.data?.users?.[0] || subUserResponse.data?.[0],
        sampleStaff: csStaffResponse?.data?.[0]
      });

      // Process admin users (matching mobile app exactly)
      if (adminResponse.success && adminResponse.data?.users) {
        addUsers(adminResponse.data.users.map((user) => ({
          id: user.id,
          name: `${user.email} (Admin)`,
          email: user.email,
          role: 'admin'
        })));
      }

      // Process manager users (matching mobile app exactly)
      if (managerResponse.success && managerResponse.data?.users) {
        addUsers(managerResponse.data.users.map((user) => ({
          id: user.id,
          name: `${user.email} (Manager)`,
          email: user.email,
          role: 'manager'
        })));
      }

      // Process sub_user (staff) users (matching mobile app exactly)
      if (subUserResponse.success && subUserResponse.data?.users) {
        addUsers(subUserResponse.data.users.map((user) => ({
          id: user.id,
          name: `${user.email} (Staff)`,
          email: user.email,
          role: 'sub_user'
        })));
      }

      // Process customer_support staff (from staff status API which includes name) (matching mobile app exactly)
      let csStaff = [];
      if (csStaffResponse?.success && csStaffResponse?.data) {
        console.log('🔍 Staff status response:', csStaffResponse.data);
        const filteredCsStaff = csStaffResponse.data.filter(s => s.role === 'customer_support');
        addUsers(filteredCsStaff.map((staff) => ({
          id: staff.id,
          name: staff.name || `${staff.email} (CS)`,
          email: staff.email,
          role: 'customer_support',
        })));
        // Populate csStaffUsers for filter dropdown (matching mobile app)
        csStaff = filteredCsStaff.map((staff) => ({
          id: staff.id,
          name: staff.name || `${staff.email} (CS)`,
          email: staff.email,
          role: 'customer_support',
        }));
      }

      console.log('Fetched users:', allUsers.length);
      setAdminUsers(allUsers);
      setCsStaffUsers(csStaff);

    } catch (error) {
      console.error('Error fetching users:', error);
      setAdminUsers([]);
      setCsStaffUsers([]);
    }
  };

  // RERA Verification handler (matching mobile app exactly)
  const handleReraVerification = async (action) => {
    if (!reraModalTask) return;
    const reason = reraRejectReason.trim();
    if (action === 'rejected' && !reason) {
      toast.error('Reason is required');
      return;
    }
    setReraProcessing(true);
    try {
      const userId = reraModalTask.related_to_id;
      const response = await userService.adminVerifyRera(userId, action, action === 'rejected' ? reason : null);
      if (response.success) {
        try {
          await taskService.updateTask(reraModalTask.id, { status: action === 'verified' ? 'completed' : 'cancelled' });
        } catch (e) { console.log('Task update error:', e); }
        toast.success(`RERA ${action === 'verified' ? 'verified' : 'rejected'} successfully`);
        setReraModalVisible(false);
        setReraModalTask(null);
        setReraRejectReason('');
        fetchTasks();
      } else {
        toast.error(response.message || 'Action failed');
      }
    } catch (e) {
      console.error('RERA verification error:', e);
      toast.error('Failed to process RERA verification');
    } finally {
      setReraProcessing(false);
    }
  };

  // GST Verification tasks are created on registration with title "GST Verification"
  const isGstTask = (rawTask) => {
    const taskType = rawTask?.task_type || rawTask?.type || rawTask?.category || '';
    const taskTitle = rawTask?.task_title || rawTask?.title || '';
    return taskType === 'gst_verification' || (taskType === 'verification' && taskTitle.toLowerCase().includes('gst'));
  };

  // GST Verification handler - the verify endpoint updates the user's GST status and closes the task
  const handleGstVerification = async (action) => {
    if (!gstModalTask) return;
    const reason = gstRejectReason.trim();
    if (action === 'rejected' && !reason) {
      toast.error('Please enter a rejection reason');
      return;
    }
    setGstProcessing(true);
    try {
      const response = await userService.adminVerifyGst(gstModalTask.related_to_id, action, action === 'rejected' ? reason : null);
      if (response?.success) {
        toast.success(`GST ${action === 'verified' ? 'verified' : 'rejected'} successfully`);
        setGstModalVisible(false);
        setGstModalTask(null);
        setGstRejectReason('');
        fetchTasks();
      } else {
        toast.error(response?.message || 'Action failed');
      }
    } catch (e) {
      console.error('GST verification error:', e);
      toast.error('Failed to process GST verification');
    } finally {
      setGstProcessing(false);
    }
  };

  // Edit Task Functions (matching React Native app)
  const handleEditTask = (task) => {
    console.log('📝 Opening edit modal for task:', task);

    const rawTask = task.originalTask || task;
    const taskStatus = rawTask.status || '';

    // Block editing completed/rejected/cancelled tasks
    if (taskStatus === 'completed' || taskStatus === 'rejected' || taskStatus === 'cancelled') {
      return;
    }

    // Intercept RERA verification tasks — open special modal (matching mobile app)
    const taskType = rawTask.task_type || rawTask.type || rawTask.category || '';
    const taskTitle = rawTask.task_title || rawTask.title || '';
    if (taskType === 'rera_verification' || (taskType === 'verification' && taskTitle.toLowerCase().includes('rera'))) {
      setReraModalTask(rawTask);
      setReraRejectReason('');
      setReraModalVisible(true);
      return;
    }

    // Intercept GST verification tasks — open GST modal
    if (isGstTask(rawTask)) {
      setGstModalTask(rawTask);
      setGstRejectReason('');
      setGstModalVisible(true);
      return;
    }

    setSelectedTask(task.originalTask || task);

    // Format date for display (if exists)
    let formattedDate = '';
    if (task.originalTask?.due_date) {
      try {
        const date = new Date(task.originalTask.due_date);
        const day = date.getDate().toString().padStart(2, '0');
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        formattedDate = `${day} ${month} ${year}`;
      } catch (e) {
        console.error('Error formatting date:', e);
      }
    }

    // Set individual edit form fields
    setEditTaskName(task.originalTask?.title || task.title || '');
    setEditDescription(task.originalTask?.description || task.subtitle || '');
    setEditTaskType(task.originalTask?.category || '');
    setEditPriority(task.originalTask?.priority || 'medium');
    setEditStatus(task.originalTask?.status || 'pending');
    setEditAssignedTo(task.originalTask?.assigned_to || '');
    setEditDueDate(formattedDate);

    setEditModalVisible(true);
  };

  // handleUpdateTask function matching AdminTask.js exactly
  const handleUpdateTask = async () => {
    try {
      if (!editTaskName || !editTaskType || !editPriority || !editStatus) {
        toast.warning('Please fill all required fields');
        return;
      }

      setLoading(true);

      // Convert date safely
      let isoDate = null;
      if (editDueDate) {
        try {
          // editDueDate is in format like "11/12/2025" from toLocaleDateString()
          const dateObj = new Date(editDueDate);
          if (!isNaN(dateObj.getTime())) {
            isoDate = dateObj.toISOString();
          }
        } catch (e) {
          console.error('Date parsing error:', e);
        }
      }

      const taskData = {
        title: editTaskName,
        description: editDescription,
        category: editTaskType, // Backend expects 'category' field
        priority: editPriority,
        status: editStatus,
        assigned_to: editAssignedTo || null,
        due_date: isoDate,
      };

      console.log('Updating task with data:', taskData);
      const response = await taskService.updateTask(selectedTask.id, taskData);
      console.log('Update task response:', JSON.stringify(response, null, 2));

      // Check if response is successful (api.js returns response.data directly)
      if (response && (response.success === true || response.data?.success === true)) {
        console.log('✅ Update successful - closing modal and refreshing list');

        // Close modal and clear selected task
        setEditModalVisible(false);
        setSelectedTask(null);

        // Clear all edit fields
        setEditTaskName('');
        setEditTaskType('');
        setEditDescription('');
        setEditPriority('Medium');
        setEditStatus('pending');
        setEditAssignedTo('');
        setEditDueDate('');
        // setEditTaskOwner(''); // Unused for now

        // Refresh task list
        await fetchTasks();

        // Show success message after everything is done
        toast.success('Task updated successfully');
      } else {
        console.log('❌ Update failed - response:', response);
        toast.error(response?.message || 'Failed to update task');
      }
    } catch (error) {
      console.error('Error updating task:', error);
      toast.error(error.message || 'Failed to update task');
    } finally {
      setLoading(false);
    }
  };

  // This useEffect moved to after state declarations

  // fetchApprovalProjects function - matching AdminTask.js exactly
  const fetchApprovalProjects = async () => {
    try {
      setApprovalLoading(true);
      console.log('🔄 Starting fetchApprovalProjects...');

      const [statsRes, projectsRes, pendingRes] = await Promise.all([
        propertyService.getApprovalStats(),
        propertyService.getAdminProjects({ page: 1, limit: 100 }),
        // Pending projects separately: the list above is ordered by created_at, so older
        // projects that were edited & resubmitted after rejection would fall outside it
        propertyService.getAdminProjects({ page: 1, limit: 1000, approval_status: 'pending' }),
      ]);

      console.log('📊 Stats response:', statsRes);
      console.log('🏗️ Projects response:', projectsRes);

      if (statsRes.success) {
        setApprovalStats(statsRes.data);
        console.log('✅ Approval stats set:', statsRes.data);
      } else {
        console.log('❌ Stats response not successful');
      }

      if (projectsRes.success) {
        const projects = projectsRes.data.projects || projectsRes.data || [];
        const pending = pendingRes?.success ? (pendingRes.data.projects || pendingRes.data || []) : [];
        const seen = new Set(projects.map(p => p.id));
        setApprovalProjects([...projects, ...pending.filter(p => !seen.has(p.id))]);
        console.log('✅ Approval projects set:', projects.length, 'projects');
        console.log('📦 Sample project:', projects[0]);
      } else {
        console.log('❌ Projects response not successful');
        setApprovalProjects([]);
      }
    } catch (error) {
      console.error('❌ Error fetching approval projects:', error);
      setApprovalProjects([]);
    } finally {
      setApprovalLoading(false);
    }
  };

  // Project Verification functions (matching mobile app exactly)
  const handleApproveProject = async (project) => {
    try {
      setActionLoading(true);
      const response = await propertyService.approveProject(project.id);
      if (response.success) {
        toast.success('Project accepted successfully');
        fetchApprovalProjects();
      } else {
        toast.error('Error: ' + (response.message || 'Failed to approve project'));
      }
    } catch (error) {
      console.error('Error approving project:', error);
      toast.error('Error approving project');
    } finally {
      setActionLoading(false);
    }
  };

  const openRejectModal = (project) => {
    setSelectedProject(project);
    setRejectionReason('');
    setRejectModalVisible(true);
  };

  const handleRejectProject = async () => {
    if (!rejectionReason.trim()) {
      toast.warning('Please provide a rejection reason');
      return;
    }
    try {
      setActionLoading(true);
      const response = await propertyService.rejectProject(selectedProject.id, rejectionReason);
      if (response.success) {
        toast.success('Project rejected successfully');
        setRejectModalVisible(false);
        setRejectionReason('');
        fetchApprovalProjects();
      } else {
        toast.error('Error: ' + (response.message || 'Failed to reject project'));
      }
    } catch (error) {
      console.error('Error rejecting project:', error);
      toast.error('Error rejecting project');
    } finally {
      setActionLoading(false);
    }
  };

  // Claim project (matching app's handleClaimProject exactly)
  const handleClaimProject = async (project) => {
    try {
      const response = await propertyService.claimProject(project.id);
      if (response.success) {
        setApprovalProjects(prev =>
          prev.map(p => p.id === project.id ? { ...p, assigned_to: response.data?.project?.assigned_to || 'claimed' } : p)
        );
        fetchApprovalProjects();
      }
    } catch (e) {
      if (e?.response?.status === 409) {
        toast.error('Already Claimed: This project has been claimed by another staff member.');
        fetchApprovalProjects();
      } else {
        toast.error('Error: Failed to claim project. Please try again.');
      }
    }
  };

  // Welcome Call functionality (matching mobile app exactly)
  const handleWelcomeCall = async (task) => {
    // If task is unclaimed, claim it first
    if (!task.assigned_to) {
      try {
        await adminTaskService.claimTask(task.id);
      } catch (e) {
        if (e?.response?.status === 409) {
          toast.error('Already Claimed: This task has been claimed by another agent.');
          fetchWelcomeCallTasks();
          return;
        }
      }
    }

    // For agency/builder: show "Select who to call" modal (matching AdminTask.js mobile flow)
    if (['agency', 'builder'].includes(task.target_user_type) && task.rep_phone) {
      setPendingCallTask(task);
      setPhonePickerVisible(true);
    } else {
      // Single contact — dial directly and show feedback modal
      const phoneNumber = task.target_user_phone;
      if (!phoneNumber) {
        toast.warning('No phone number available for this task');
        return;
      }
      window.open(`tel:${phoneNumber}`, '_self');
      setCurrentCallTask(task);
      setTimeout(() => {
        setFeedbackModalVisible(true);
      }, 2000);
    }
  };

  const handlePhoneSelect = (selectedPhone) => {
    setPhonePickerVisible(false);
    const task = pendingCallTask;
    setPendingCallTask(null);
    if (!selectedPhone || !task) return;
    window.open(`tel:${selectedPhone}`, '_self');
    setCurrentCallTask(task);
    setTimeout(() => {
      setFeedbackModalVisible(true);
    }, 2000);
  };

  const handleCompleteWelcomeTask = async () => {
    if (!feedbackText.trim()) {
      toast.warning('Required: Please enter feedback before completing the task');
      return;
    }
    try {
      setWelcomeLoading(true);
      const response = await adminTaskService.completeTask(currentCallTask.id, feedbackText.trim());
      if (response.success || response.data?.success) {
        toast.success('Welcome call task completed successfully');
        setFeedbackModalVisible(false);
        setFeedbackText('');
        setCurrentCallTask(null);
        fetchWelcomeCallTasks();
      } else {
        toast.error('Error: ' + (response.message || 'Failed to complete task'));
      }
    } catch (error) {
      console.error('Error completing welcome task:', error);
      toast.error('Error: Failed to complete task');
    } finally {
      setWelcomeLoading(false);
    }
  };

  const handleOpenScheduleModal = async () => {
    setScheduleTaskName('');
    setScheduleAssignedTo('');
    setScheduleDate('');
    setScheduleTime('');

    // Fetch staff status with availability for the Assigned To picker (matching mobile app exactly)
    try {
      const statusRes = await adminStaffService.getAllStaffStatus();
      const staffData = statusRes?.data || [];
      const csStaff = (Array.isArray(staffData) ? staffData : [])
        .filter(s => s.role === 'customer_support')
        .map(s => ({
          staff_id: s.id,
          id: s.id,
          name: s.name || s.email,
          email: s.email,
          role: s.role,
          is_online: s.availability?.is_online || false,
          status: s.availability?.status || 'offline',
        }));
      // Use fetched CS staff, or fall back to csStaffUsers from initial load
      setFreeStaff(csStaff.length > 0 ? csStaff : csStaffUsers);
    } catch (e) {
      console.error('Error fetching staff status:', e);
      // Fall back to csStaffUsers already loaded during fetchAdminUsers
      setFreeStaff(csStaffUsers);
    }

    setScheduleModalVisible(true);
  };

  const handleCreateScheduledTask = async () => {
    if (!scheduleTaskName.trim()) {
      toast.warning('Please enter a task name');
      return;
    }
    if (!scheduleDate) {
      toast.warning('Please select a date and time');
      return;
    }

    try {
      setWelcomeLoading(true);

      // Create scheduled datetime (simplified for web)
      const scheduledDatetime = `${scheduleDate} ${scheduleTime || '10:00 AM'}`;

      const data = {
        task_name: scheduleTaskName.trim(),
        target_user_id: currentCallTask?.target_user_id || null,
        target_user_type: currentCallTask?.target_user_type || null,
        target_user_name: currentCallTask?.target_user_name || null,
        target_user_phone: currentCallTask?.target_user_phone || null,
        assigned_to: scheduleAssignedTo || null,
        scheduled_datetime: scheduledDatetime,
      };

      const response = await adminTaskService.createScheduledTask(data);
      if (response.success || response.data?.success) {
        // Complete/remove the old task after follow-up is created
        if (currentCallTask?.id) {
          try {
            await adminTaskService.completeTask(currentCallTask.id, feedbackText.trim() || 'Follow-up task created');
          } catch (err) {
            console.warn('Failed to complete old task:', err);
          }
        }
        toast.success('Scheduled task created successfully');
        setScheduleModalVisible(false);
        setFeedbackModalVisible(false);
        setFeedbackText('');
        setCurrentCallTask(null);
        fetchWelcomeCallTasks();
      } else {
        toast.error('Error: ' + (response.message || 'Failed to create scheduled task'));
      }
    } catch (error) {
      console.error('Error creating scheduled task:', error);
      toast.error('Error creating scheduled task');
    } finally {
      setWelcomeLoading(false);
    }
  };

  // fetchWelcomeCallTasks function - matching AdminTask.js exactly
  const fetchWelcomeCallTasks = async () => {
    try {
      setWelcomeLoading(true);
      console.log('📞 Starting fetchWelcomeCallTasks...');

      const response = await adminTaskService.getWelcomeCallTasks();

      console.log('📞 Welcome call tasks response:', response);

      if (response.success && response.data) {
        setWelcomeTasks(response.data);
        console.log('✅ Welcome call tasks set:', response.data);
        console.log('📊 Welcome tasks counts:', {
          active: response.data.active?.length || 0,
          missed: response.data.missed?.length || 0,
          backlog: response.data.backlog?.length || 0,
          completed: response.data.completed?.length || 0
        });
      } else if (response.data?.success && response.data?.data) {
        setWelcomeTasks(response.data.data);
        console.log('✅ Welcome call tasks set (nested):', response.data.data);
      } else {
        console.log('❌ Welcome call tasks response not successful');
        setWelcomeTasks({ active: [], missed: [], backlog: [], completed: [], counts: {} });
      }
    } catch (error) {
      console.error('❌ Error fetching welcome call tasks:', error);
      setWelcomeTasks({ active: [], missed: [], backlog: [], completed: [], counts: {} });
    } finally {
      setWelcomeLoading(false);
    }
  };

  // Load data when screen comes into focus - matching AdminTask.js
  useEffect(() => {
    console.log('📱 Admin web screen focused - fetching tasks');
    fetchTasks();
    fetchAdminUsers();
    fetchApprovalProjects();
    fetchWelcomeCallTasks();
  }, []);

  // Refresh welcome tasks when project call picker modal opens
  useEffect(() => {
    if (projectCallPickerVisible) {
      fetchWelcomeCallTasks();
    }
  }, [projectCallPickerVisible]);

  // Refresh welcome tasks when call feedback modal opens
  useEffect(() => {
    if (feedbackModalVisible) {
      fetchWelcomeCallTasks();
    }
  }, [feedbackModalVisible]);

  // Also fetch when date filters change - matching AdminTask.js
  useEffect(() => {
    console.log('🔄 Date filters changed - fetching tasks');
    fetchTasks();
  }, [fromDate1, toDate1]); // activeFilter removed - we filter on frontend

  // Helper function to get sections like mobile app - matching AdminTask.js display EXACTLY
  const getSectionsFromData = () => {
    const sections = [];

    const showWelcome = filterTaskType !== 'verification';
    const showVerification = filterTaskType !== 'welcome_call';
    const filteredWelcome = getFilteredWelcomeTasks();

    // === MISSED CALLS Section (All and Calls tabs) - matching mobile app ===
    if (showWelcome && (activeFilter === 'All' || activeFilter === 'Calls') && filteredWelcome.missed && filteredWelcome.missed.length > 0) {
      sections.push({
        id: 'missed_calls',
        title: 'Missed Tasks',
        count: filteredWelcome.missed.length,
        showCall: true,
        items: filteredWelcome.missed.map(task => ({
          id: task.id,
          title: task.task_title || `Welcome Call - ${task.target_user_name || 'User'}`,
          subtitle: `Phone: ${task.target_user_phone || 'No phone'}`,
          assigned: task.assigned_to_name || getUserNameById(task.assigned_to) || 'Unassigned',
          timeAgo: getTimeAgo(task.created_at || task.scheduled_at),
          status: task.status || 'todo',
          colorClass: 'tk-accent-left-red',
          userType: task.target_user_type || 'user',
          originalTask: task
        }))
      });
    }

    // === WELCOME CALLS Section (All tab only) - matching mobile app ===
    if (showWelcome && activeFilter === 'All' && filteredWelcome.active && filteredWelcome.active.length > 0) {
      const filteredActiveTasks = filteredWelcome.active
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      console.log('🔍 Showing all active tasks (matching mobile):', filteredActiveTasks.length);
      console.log('🔍 All tasks:', filteredActiveTasks.map(t => ({
        id: t.id.substr(-8),
        title: t.task_title,
        created: t.created_at,
        assigned: t.assigned_to ? 'assigned' : 'unassigned'
      })));


      if (filteredActiveTasks.length > 0) {
        sections.push({
          id: 'welcome_calls',
          title: 'Welcome calls',
          count: filteredActiveTasks.length,
          showCall: true,
          items: filteredActiveTasks.map(task => ({
            id: task.id,
            title: task.task_title || `Welcome Call - ${task.target_user_name || 'User'}`,
            subtitle: `Phone: ${task.target_user_phone || 'No phone'}`,
            assigned: task.assigned_to_name || getUserNameById(task.assigned_to) || 'Unassigned',
            timeAgo: getTimeAgo(task.created_at || task.scheduled_at),
            status: task.status || 'todo',
            colorClass: getColorClassByStatus(task.status || 'todo'),
            userType: task.target_user_type || 'user',
            originalTask: task
          }))
        });
      }
    }

    // === WELCOME CALL BACKLOG Section (Calls tab only) - matching mobile app ===
    if (showWelcome && activeFilter === 'Calls' && filteredWelcome.backlog && filteredWelcome.backlog.length > 0) {
      sections.push({
        id: 'welcome_call_backlog',
        title: 'Welcome Call Backlog',
        count: filteredWelcome.backlog.length,
        showCall: true,
        items: filteredWelcome.backlog.map(task => ({
          id: task.id,
          title: task.task_title || `Welcome Call - ${task.target_user_name || 'User'}`,
          subtitle: `Phone: ${task.target_user_phone || 'No phone'}`,
          assigned: task.assigned_to_name || getUserNameById(task.assigned_to) || 'Unassigned',
          timeAgo: getTimeAgo(task.created_at || task.scheduled_at),
          status: 'backlog',
          colorClass: 'tk-accent-left-red',
          userType: task.target_user_type || 'user',
          originalTask: task
        }))
      });
    }

    // === COMPLETED WELCOME CALLS Section (Site Visits/Completed tab only) - matching mobile app ===
    if (showWelcome && activeFilter === 'Site Visits' && filteredWelcome.completed && filteredWelcome.completed.length > 0) {
      sections.push({
        id: 'completed_welcome_calls',
        title: 'Completed Welcome Calls',
        count: filteredWelcome.completed.length,
        showCall: true,
        items: filteredWelcome.completed.map(task => ({
          id: task.id,
          title: task.task_title || `Welcome Call - ${task.target_user_name || 'User'}`,
          subtitle: `${task.target_user_type || 'User'} - ${task.target_user_name || 'Unknown'}`,
          assigned: task.assigned_to_name || getUserNameById(task.assigned_to) || 'Unassigned',
          timeAgo: getTimeAgo(task.created_at || task.scheduled_at),
          status: 'completed',
          colorClass: 'tk-accent-left-green',
          userType: task.target_user_type || 'user',
          originalTask: task
        }))
      });
    }

    // === PROJECT VERIFICATION Section (matching mobile app) ===
    const projectsToShow = showVerification ? getFilteredProjects() : [];
    if (projectsToShow.length > 0) {
      sections.push({
        id: 'project_verification',
        title: 'Project Verification',
        count: projectsToShow.length,
        showCall: false,
        items: projectsToShow.map(project => ({
          id: project.id,
          title: project.property_title || project.title || 'Project Verification',
          subtitle: `Builder: ${project.owner_name || project.city || 'N/A'}`,
          assigned: project.assigned_to_name || getUserNameById(project.assigned_to) || 'Unassigned',
          // Resubmitted: time since resubmission (backend bumps updated_at on resubmit).
          // Rejected: time since rejection (backend stores the decision time in approved_at for both approve/reject).
          timeAgo: getTimeAgo(
            isResubmittedProject(project) ? (project.updated_at || project.created_at)
              : project.approval_status === 'rejected' ? (project.approved_at || project.updated_at || project.created_at)
              : project.created_at
          ),
          status: project.approval_status || 'pending',
          colorClass: getColorClassByStatus(project.approval_status),
          originalTask: project
        }))
      });
    }

    // === WELCOME_CALL Section removed - mobile app only shows "Welcome calls" section ===
    // Regular welcome_call tasks are not shown separately in the mobile app

    // === OTHER TASK CATEGORIES (excluding welcome_call) - matching mobile app ===
    const filteredTasks = (showVerification ? getFilteredTasks() : []).filter(task =>
      task.category !== 'welcome_call' && task.task_type !== 'welcome_call' && task.type !== 'welcome_call'
    );
    const groupedTasks = {};

    filteredTasks.forEach(task => {
      const category = task.task_type || task.category || task.type || 'general';
      const categoryKey = category.toLowerCase().replace(/\s+/g, '-');

      if (!groupedTasks[categoryKey]) {
        groupedTasks[categoryKey] = {
          id: categoryKey,
          title: category.charAt(0).toUpperCase() + category.slice(1),
          count: 0,
          showCall: true,
          items: []
        };
      }

      // Convert API task to card format
      const taskCard = {
        id: task.id,
        title: task.task_title || task.title || 'Untitled Task',
        subtitle: task.description || 'No description',
        assigned: getUserNameById(task.assigned_to, task) || 'Unassigned',
        timeAgo: getTimeAgo(task.created_at),
        status: task.status || 'pending',
        colorClass: getColorClassByStatus(task.status),
        originalTask: task
      };

      groupedTasks[categoryKey].items.push(taskCard);
      groupedTasks[categoryKey].count++;
    });

    sections.push(...Object.values(groupedTasks));

  
    const WELCOME_SECTION_IDS = ['missed_calls', 'welcome_calls', 'welcome_call_backlog', 'completed_welcome_calls'];
    const sectionRank = (s) => {
      if (s.id === 'project_verification') return 0;
      if (WELCOME_SECTION_IDS.includes(s.id)) return 2;
      return 1;
    };
    return sections.sort((a, b) => sectionRank(a) - sectionRank(b));
  };

  // A pending project that still carries a rejection reason was edited & resubmitted by the builder
  const isResubmittedProject = (p) => p.approval_status === 'pending' && !!p.rejection_reason;
  // Backlog: resubmitted projects, and pending projects older than 24hrs
  const isProjectBacklog = (p) => isResubmittedProject(p) ||
    (p.approval_status === 'pending' && (new Date() - new Date(p.created_at)) / 3600000 >= 24);
  // Available: other pending projects (within 24hrs)
  const isProjectAvailable = (p) => p.approval_status === 'pending' && !isProjectBacklog(p);

  // Helper function to filter projects based on activeFilter - matching AdminTask.js
  const getFilteredProjects = () => {
    if (activeFilter === 'Calls') {
      return approvalProjects.filter(isProjectBacklog);
    } else if (activeFilter === 'Site Visits') {
      // Completed (Approved)
      return approvalProjects.filter(p => p.approval_status === 'approved');
    } else if (activeFilter === 'Rejected') {
      // Rejected
      return approvalProjects.filter(p => p.approval_status === 'rejected');
    } else {
      return approvalProjects.filter(isProjectAvailable);
    }
  };

  // Helper function to get user name by ID - matching AdminTask.js
  const getUserNameById = (userId, task) => {
    if (!userId) return 'Unassigned';
    // First check if backend provided the name directly
    if (task?.assigned_to_name) return task.assigned_to_name;
    const user = adminUsers.find(u => u.id === userId);
    if (user) return user.name;
    if (userId.length > 20 && userId.includes('-')) return 'Admin Staff';
    return userId;
  };

  // Helper function to filter tasks based on activeFilter - matching AdminTask.js
  const getFilteredTasks = () => {
    let filtered;
    if (activeFilter === 'Calls') {
      filtered = tasks.filter(t => t.status === 'backlog');
    } else if (activeFilter === 'Site Visits') {
      filtered = tasks.filter(t => t.status === 'completed');
    } else if (activeFilter === 'Rejected') {
      // matching AdminTask.js - includes both cancelled and rejected
      filtered = tasks.filter(t => t.status === 'cancelled' || t.status === 'rejected');
    } else {
      // All tab - if filterStatus is set, let it handle the filtering (don't pre-exclude)
      // otherwise exclude terminal statuses - matching AdminTask.js
      if (filterStatus) {
        filtered = [...tasks];
      } else {
        filtered = tasks.filter(t => t.status !== 'backlog' && t.status !== 'completed' && t.status !== 'cancelled' && t.status !== 'rejected');
      }
    }

    // Apply filter modal status if set - matching AdminTask.js
    if (filterStatus) {
      filtered = filtered.filter(t => t.status === filterStatus);
    }
    // Apply filter modal task owner if set - matching AdminTask.js
    if (filterTaskOwner) {
      filtered = filtered.filter(t => t.assigned_to === filterTaskOwner);
    }
    return filtered;
  };

  // getFilteredWelcomeTasks - matching AdminTask.js exactly
  const getFilteredWelcomeTasks = () => {
    if (!filterStatus && !filterTaskOwner) return welcomeTasks;

    const filterList = (list) => {
      let filtered = list || [];
      if (filterTaskOwner) {
        filtered = filtered.filter(t => t.assigned_to === filterTaskOwner || t.claimed_by === filterTaskOwner);
      }
      return filtered;
    };

    if (filterStatus === 'missed') {
      return { ...welcomeTasks, active: [], completed: [], backlog: [], missed: filterList(welcomeTasks.missed) };
    } else if (filterStatus === 'completed') {
      return { ...welcomeTasks, active: [], missed: [], backlog: [], completed: filterList(welcomeTasks.completed) };
    } else if (filterStatus === 'backlog') {
      return { ...welcomeTasks, active: [], missed: [], completed: [], backlog: filterList(welcomeTasks.backlog) };
    } else if (filterStatus === 'in_progress') {
      return { ...welcomeTasks, missed: [], completed: [], backlog: [], active: filterList(welcomeTasks.active) };
    }

    return {
      ...welcomeTasks,
      active: filterList(welcomeTasks.active),
      missed: filterList(welcomeTasks.missed),
      completed: filterList(welcomeTasks.completed),
      backlog: filterList(welcomeTasks.backlog),
    };
  };

  // Helper function to format time ago dynamically - matching AdminTask.js exactly
  const getTimeAgo = (dateString) => {
    if (!dateString) return 'Just now';

    const now = new Date();
    const createdDate = new Date(dateString);
    const diffMs = now - createdDate;

    // Convert to different time units
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMinutes < 1) {
      return 'Just now';
    } else if (diffMinutes < 60) {
      return `${diffMinutes} ${diffMinutes === 1 ? 'minute' : 'minutes'} ago`;
    } else if (diffHours < 24) {
      return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    } else if (diffDays < 30) {
      return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
    } else {
      const diffMonths = Math.floor(diffDays / 30);
      return `${diffMonths} ${diffMonths === 1 ? 'month' : 'months'} ago`;
    }
  };

  // getStatusInfo function - available for future use if needed
  // const getStatusInfo = (taskStatus) => {
  //   const statusMap = {
  //     'todo': { text: 'To Do', bg: '#3498DB', leftBar: '#3498DB' },
  //     'pending': { text: 'Pending', bg: '#F39C12', leftBar: '#F39C12' },
  //     'in_progress': { text: 'In Progress', bg: '#9B59B6', leftBar: '#9B59B6' },
  //     'review': { text: 'Review', bg: '#1ABC9C', leftBar: '#1ABC9C' },
  //     'completed': { text: 'Completed', bg: '#27AE60', leftBar: '#27AE60' },
  //     'on_hold': { text: 'On Hold', bg: '#95A5A6', leftBar: '#95A5A6' },
  //     'cancelled': { text: 'Cancelled', bg: '#E74C3C', leftBar: '#E74C3C' },
  //     'backlog': { text: 'Backlog', bg: '#EC4899', leftBar: '#EC4899' },
  //   };
  //   return statusMap[taskStatus] || { text: 'Unknown', bg: '#9CA3AF', leftBar: '#9CA3AF' };
  // };

  const getColorClassByStatus = (status) => {
    switch (status) {
      case 'completed': return 'tk-accent-left-green';
      case 'approved': return 'tk-accent-left-green';
      case 'in_progress': return 'tk-accent-left-blue';
      case 'pending': return 'tk-accent-left-yellow';
      case 'backlog': return 'tk-accent-left-red';
      case 'cancelled': return 'tk-accent-left-red1';
      case 'rejected': return 'tk-accent-left-red1';
      default: return 'tk-accent-left-blue';
    }
  };

  // Use dynamic sections like mobile app - recalculate when activeFilter or data changes
  const sections = useMemo(() => {
    if (loading) return [];

    // DEBUG: Detailed count calculation like mobile app
    const availableTasksCount = tasks.filter(t => t.status !== 'backlog' && t.status !== 'completed' && t.status !== 'cancelled').length;
    const availableProjectsCount = approvalProjects.filter(isProjectAvailable).length;
    const activeWelcomeCount = welcomeTasks.active?.length || 0;
    const totalAvailableCount = availableTasksCount + availableProjectsCount + activeWelcomeCount;

    console.log('🔄 DETAILED COUNT BREAKDOWN (matching mobile app):', {
      activeFilter,
      'Regular Tasks': {
        total: tasks.length,
        available: availableTasksCount,
        backlog: tasks.filter(t => t.status === 'backlog').length,
        completed: tasks.filter(t => t.status === 'completed').length,
        cancelled: tasks.filter(t => t.status === 'cancelled').length,
        sampleTasks: tasks.slice(0, 3).map(t => ({ id: t.id, status: t.status, title: t.title }))
      },
      'Approval Projects': {
        total: approvalProjects.length,
        available: availableProjectsCount,
        sampleProjects: approvalProjects.slice(0, 3).map(p => ({ id: p.id, status: p.approval_status, created: p.created_at }))
      },
      'Welcome Tasks': {
        active: activeWelcomeCount,
        missed: welcomeTasks.missed?.length || 0,
        backlog: welcomeTasks.backlog?.length || 0,
        completed: welcomeTasks.completed?.length || 0
      },
      'FINAL COUNTS': {
        'Available Task (should match mobile)': totalAvailableCount,
        'Mobile shows': 2,
        'Difference': totalAvailableCount - 2
      }
    });

    const generatedSections = getSectionsFromData();
    console.log('✅ Generated sections:', generatedSections.map(s => ({ id: s.id, title: s.title, count: s.count })));

    return generatedSections;
  }, [loading, tasks, activeFilter, adminUsers, approvalProjects, welcomeTasks, filterTaskOwner, filterTaskType, filterStatus]);


  // Form state matching AdminTask.js exact naming
  const [taskOwner, setTaskOwner] = useState('');
  const [ticketType, setTicketType] = useState('');
  const [taskType, setTaskType] = useState('');
  const [status, setStatus] = useState('');
  const [description, setDescription] = useState('');
  const [taskName, setTaskName] = useState('');
  const [priority, setPriority] = useState('');
  const [fromDate, setFromDate] = useState('');

  const [filterDates, setFilterDates] = useState({
    startDate: "",
    endDate: "",
  });

  // Set today's date as default for filter date pickers - matching AdminTask.js
  useEffect(() => {
    const today = new Date();
    const day = today.getDate().toString().padStart(2, '0');
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    const month = monthNames[today.getMonth()];
    const year = today.getFullYear();
    const formattedDate = `${day} ${month} ${year}`;

    // Set default dates only if they're empty
    if (!fromDate1) setFromDate1(formattedDate);
    if (!toDate1) setToDate1(formattedDate);
  }, []); // Run only once on mount

  // 📅 Open date picker
  const openDatePicker = (type) => {
    setCurrentDateType(type);

    // Position calculation for date picker (currently not used for mobile-style modal)
    // const rect = e.currentTarget.getBoundingClientRect();
    // const datePickerHeight = 220;
    // Position calculation (currently not used for mobile-style modal)
    // let topPosition;
    // if (type === "taskDate") {
    //   topPosition = rect.top + window.scrollY - datePickerHeight - 10;
    // } else if (type === "startDate" || type === "endDate") {
    //   topPosition = rect.top + window.scrollY;
    // } else {
    //   topPosition = rect.bottom + window.scrollY + 10;
    // }


    let savedDate;
    if (type === "taskDate") {
      savedDate = fromDate;
    } else {
      savedDate = filterDates[type];
    }

    let dayIdx, monthIdx, yearIdx;

    if (savedDate) {
      const [d, m, y] = savedDate.split(" ");
      dayIdx = parseInt(d, 10) - 1;
      monthIdx = months.indexOf(m);
      yearIdx = years.indexOf(y);
    } else {
      const today = new Date();
      const d = today.getDate().toString().padStart(2, "0");
      const m = months[today.getMonth()];
      const y = today.getFullYear().toString();
      dayIdx = parseInt(d, 10) - 1;
      monthIdx = months.indexOf(m);
      yearIdx = years.indexOf(y);
    }

    setSelectedDayIdx(dayIdx >= 0 ? dayIdx : 0);
    setSelectedMonthIdx(monthIdx >= 0 ? monthIdx : 0);
    setSelectedYearIdx(yearIdx >= 0 ? yearIdx : 0);

    setIsDatePickerVisible(true);
  };

  // 📅 scroll to selected index when opening date picker
  useEffect(() => {
    if (!isDatePickerVisible) return;

    const scrollToIndex = (ref, index) => {
      if (!ref.current) return;
      // Center the selected item in the middle row by scrolling it to center position
      ref.current.scrollTop = index * ITEM_HEIGHT;
    };

    requestAnimationFrame(() => {
      scrollToIndex(dayRef, selectedDayIdx);
      scrollToIndex(monthRef, selectedMonthIdx);
      scrollToIndex(yearRef, selectedYearIdx);
    });
  }, [isDatePickerVisible, selectedDayIdx, selectedMonthIdx, selectedYearIdx]);

  const handleSaveDate = () => {
    const day = days[selectedDayIdx] ?? days[0];
    const month = months[selectedMonthIdx] ?? months[0];
    const year = years[selectedYearIdx] ?? years[0];
    const picked = `${day} ${month} ${year}`;

    if (currentDateType === "taskDate") {
      setFromDate(picked);
    } else if (currentDateType === "startDate") {
      setFromDate1(picked);
      setFilterDates((prev) => ({ ...prev, startDate: picked }));
    } else if (currentDateType === "endDate") {
      setToDate1(picked);
      setFilterDates((prev) => ({ ...prev, endDate: picked }));
    }

    setIsDatePickerVisible(false);
  };

  const handleScroll = (ref, setIndex, itemCount) => {
    if (!ref.current) return;

    if (scrollTimeout) clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(() => {
      if (!ref.current) return;
      const { scrollTop } = ref.current;
      const currentIndex = Math.round(scrollTop / ITEM_HEIGHT);

      // Calculate actual index in the original array
      const actualIndex = currentIndex % itemCount;

      setIndex(actualIndex);

      // Only snap if not already at the correct position (avoid auto-scroll)
      const targetScrollTop = currentIndex * ITEM_HEIGHT;
      const diff = Math.abs(scrollTop - targetScrollTop);

      if (diff > 5) {
        ref.current.scrollTo({
          top: targetScrollTop,
          behavior: "smooth",
        });
      }
    }, 150);
  };

  // ScrollDatePicker component (same as Dashboard)
  const ScrollDatePicker = ({ onSave, onCancel }) => {
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const years = Array.from({ length: 20 }, (_, i) => 2020 + i);

    const [selected, setSelected] = useState({ day: 2, month: "Feb", year: 2021 });

    const handleScroll = (e, type) => {
      const index = Math.round(e.target.scrollTop / 40);
      if (type === "day") setSelected({ ...selected, day: days[index] });
      if (type === "month") setSelected({ ...selected, month: months[index] });
      if (type === "year") setSelected({ ...selected, year: years[index] });
    };

    return (
      <div className="custom-scroll-picker-overlay">
        <div className="custom-scroll-picker">
          <div className="picker-columns">
            <div className="picker-highlight" />
            {/* Days */}
            <div className="scroll-column" onScroll={(e) => handleScroll(e, "day")}>
              {days.map((d) => (
                <div key={d} className={d === selected.day ? "active" : ""}>
                  {String(d).padStart(2, "0")}
                </div>
              ))}
            </div>
            {/* Months */}
            <div className="scroll-column" onScroll={(e) => handleScroll(e, "month")}>
              {months.map((m) => (
                <div key={m} className={m === selected.month ? "active" : ""}>
                  {m}
                </div>
              ))}
            </div>
            {/* Years */}
            <div className="scroll-column" onScroll={(e) => handleScroll(e, "year")}>
              {years.map((y) => (
                <div key={y} className={y === selected.year ? "active" : ""}>
                  {y}
                </div>
              ))}
            </div>
          </div>
          <div className="picker-actions">
            <button onClick={onCancel}>Cancel</button>
            <button onClick={() => onSave(selected)}>Save</button>
          </div>
        </div>
      </div>
    );
  };

  function openAddTask() {
    // Reset all form fields to match AdminTask.js
    setTaskName('');
    setDescription('');
    setTaskType('');
    setPriority('');
    setStatus('');
    setFromDate('');
    setFromDate1('');
    setTaskOwner('');
    // reset picker temp to defaults
    setPickerTmpDate({ day: "02", month: "Feb", year: "2021" });
    setPickerTmpTime({ hour: "04", minute: "30", period: "PM" });
    setAddOpen(true);
  }


  // applyFilters function - matching AdminTask.js exactly
  const applyFilters = () => {
    setFilterOpen(false);
    if (filterTaskType === 'welcome_call') {
      fetchWelcomeCallTasks();
    }
    fetchTasks();
  };

  // resetFilters function - matching AdminTask.js exactly
  const resetFilters = () => {
    setFromDate1('');
    setToDate1('');
    setFilterDates({ startDate: '', endDate: '' });
    setFilterTaskOwner('');
    setFilterTaskType('');
    setFilterStatus('');
    setFilterOpen(false);
    fetchTasks();
  };

  // handleCreateTask function matching AdminTask.js exactly
  const handleCreateTask = async () => {
    try {
      // Validation
      if (!taskName || !taskType || !priority || !status || !fromDate) {
        toast.warning('Please fill all required fields');
        return;
      }

      setLoading(true);

      // Convert date from "12 November 2025" format to ISO
      let isoDate = null;
      if (fromDate) {
        try {
          // Parse "DD Month YYYY" format
          const parts = fromDate.split(' ');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'];
            const month = monthNames.indexOf(parts[1]);
            const year = parseInt(parts[2]);

            if (month !== -1) {
              const dateObj = new Date(year, month, day);
              isoDate = dateObj.toISOString();
            }
          }
        } catch (e) {
          console.error('Date parsing error:', e);
          toast.warning('Invalid date format');
          setLoading(false);
          return;
        }
      }

      const taskData = {
        title: taskName,
        description: description,
        category: taskType, // Backend expects 'category' field
        priority: priority,
        status: status,
        due_date: isoDate, // Send in ISO format
        assigned_to: taskOwner || null,
      };
      console.log("Creating task with data:", taskData);
      const response = await taskService.createTask(taskData);
      console.log("task response data:", response);

      // Check if response is successful (api.js returns response.data directly)
      if (response.success || response.data?.success) {
        toast.success('Task created successfully');

        // Close modal first
        setAddOpen(false);

        // Reset all form fields
        setTaskName('');
        setDescription('');
        setTaskType('');
        setPriority('');
        setStatus('');
        setFromDate('');
        setFromDate1('');
        setTaskOwner('');

        // Refresh task list to show the new task
        await fetchTasks();
      } else {
        // Handle unsuccessful response
        const errorMessage = response.message || response.data?.message || 'Failed to create task';
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error creating task:', error);
      toast.error(error.response?.data?.message || error.message || 'Failed to create task');
    } finally {
      setLoading(false);
    }
  };

  // helper to apply temporary date/time into form (from picker)
  function applyPickerToForm() {
    const dateValue = `${pickerTmpDate.day} ${pickerTmpDate.month} ${pickerTmpDate.year}`;
    const timeValue = `${pickerTmpTime.hour}:${pickerTmpTime.minute} ${pickerTmpTime.period}`;
    setFromDate(`${dateValue} ${timeValue}`);
    setDatePickerOpen(false);
  }

  // Unused function - keeping for potential future use
  // function handleDatePick(dateStr) {
  //   setTaskForm((s) => ({ ...s, date: dateStr }));
  //   setDatePickerOpen(false);
  // }

  return (
    <div className="tk-page d-flex">
      <LeftNav />

      <div className="tk-content-wrap flex-grow-1">
        <TopNav />

        <div className="p-4">
          <div className="card tk-container-card ">
            <div className="card-body">
              {/* Main header */}
              <div className="d-flex align-items-center justify-content-between tk-header-row">
                <div className="d-flex align-items-center gap-3">

                  <h2 className="tk-title mb-0">Tasks</h2>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-outline-secondary tk-filters-btn"
                    onClick={() => setFilterOpen(true)}
                    title="Filters"
                  >
                    {IconFilter && <img src={IconFilter} alt="filters" className="tk-icon-sm" />}
                    <span className="ms-2">Filters</span>
                  </button>
                </div>
              </div>

              {/* Filters - matching AdminTask.js exact structure with approval projects and welcome tasks */}
              <div className="d-flex align-items-center justify-content-start gap-3 mt-3 tk-tabs-row">
                {[
                  {
                    key: 'All',
                    label: 'Available Task',
                    count: (welcomeTasks.active?.length || 0) +
                           approvalProjects.filter(isProjectAvailable).length +
                           tasks.filter(t =>
                             t.status !== 'backlog' &&
                             t.status !== 'completed' &&
                             t.status !== 'cancelled' &&
                             t.category !== 'welcome_call' &&
                             t.task_type !== 'welcome_call' &&
                             t.type !== 'welcome_call'
                           ).length,
                  },
                  {
                    key: 'Calls',
                    label: 'Backlog',
                    count: (welcomeTasks.backlog?.length || 0) +
                           (welcomeTasks.missed?.length || 0) +
                           approvalProjects.filter(isProjectBacklog).length,
                  },
                  {
                    key: 'Site Visits',
                    label: 'Completed',
                    count: (welcomeTasks.completed?.length || 0) +
                           approvalProjects.filter(p => p.approval_status === 'approved').length +
                           tasks.filter(t => t.status === 'completed' && t.category !== 'welcome_call' && t.task_type !== 'welcome_call' && t.type !== 'welcome_call').length,
                  },
                  {
                    key: 'Rejected',
                    label: 'Rejected',
                    count: tasks.filter(t => (t.status === 'cancelled' || t.status === 'rejected') && t.category !== 'welcome_call' && t.task_type !== 'welcome_call' && t.type !== 'welcome_call').length +
                           approvalProjects.filter(p => p.approval_status === 'rejected').length,
                  },
                ].map((tab) => {
                  const isActive = activeFilter === tab.key;
                  return (
                    <button
                      key={tab.key}
                      className={`btn ${isActive ? "tk-tab-active" : "tk-tab"}`}
                      onClick={() => setActiveFilter(tab.key)}
                    >
                      {tab.label} <span className="tk-pill muted">{tab.count}</span>
                    </button>
                  );
                })}
              </div>

              {/* Inner sections container: everything (all groups) inside one white rounded section */}
              <div className="tk-sections-card card mt-4">
                <div className="card-body">

                  {/* Loading State */}
                  {loading && (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
                    </div>
                  )}

                  {/* Error State */}
                  {error && (
                    <div className="alert alert-danger" role="alert">
                      <strong>Error:</strong> {error}
                      <button
                        className="btn btn-sm btn-outline-danger ms-3"
                        onClick={() => { setError(''); fetchTasks(); }}
                      >
                        Retry
                      </button>
                    </div>
                  )}

                  {/* Empty State */}
                  {!loading && !error && sections.length === 0 && tasks.length === 0 && (
                    <div className="text-center py-5">
                      <h6 className="text-muted">No tasks found</h6>
                      <p className="text-muted">Tasks from the last 7 days will appear here.</p>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={fetchTasks}
                      >
                        Refresh Tasks
                      </button>
                    </div>
                  )}

                  {/* render all sections like mobile app */}
                  {!loading && !error && sections.map((section) => (
                    <div
                      className={collapsibleSections
                        ? `tk-group tk-group-panel${expandedSections[section.id] ? ' is-open' : ''}`
                        : 'tk-group mb-4'}
                      key={section.id}
                    >
                      <div
                        className={collapsibleSections ? 'tk-group-header' : 'd-flex align-items-center justify-content-between mb-3'}
                        onClick={collapsibleSections ? () => toggleSection(section.id) : undefined}
                      >
                        <h6 className="tk-group-title mb-0">{section.title} <span className="tk-group-count">{section.count}</span></h6>
                        {collapsibleSections && (
                          <span className="tk-group-toggle">
                            <IoChevronDown size={18} />
                          </span>
                        )}
                      </div>

                      {isSectionOpen(section.id) && (<div className={collapsibleSections ? 'tk-group-body' : undefined}>
                      {/* Show empty state for sections with no items (like mobile app) */}
                      {section.items.length === 0 && (
                        <div className="text-center py-4">
                          <p className="text-muted mb-0">
                            {section.id === 'project_verification' ? 'No project verifications found' :
                              section.id === 'welcome_calls' ? 'No welcome calls found' :
                                `No ${section.title.toLowerCase()} found`}
                          </p>
                        </div>
                      )}

                      {/* each section's tasks */}
                      {(collapsibleSections
                        ? section.items.slice(0, sectionVisibleCounts[section.id] || SECTION_PAGE_SIZE)
                        : section.items
                      ).map((t) => (
                        <div className="tk-task-card card" key={t.id} onClick={() => {
                          const rawTask = t.originalTask || t;
                          const taskType = rawTask.task_type || rawTask.type || rawTask.category || '';
                          const taskTitle = rawTask.task_title || rawTask.title || t.title || '';
                          if (taskType === 'rera_verification' || (taskType === 'verification' && taskTitle.toLowerCase().includes('rera')) || isGstTask(rawTask)) {
                            handleEditTask(t);
                            return;
                          }
                          setSelectedTask(t);
                          if (t.title === "Agent Verification") {
                            setAgentModalOpen(true);
                          } else if (t.title === "Builder Verification") {
                            setBuilderModalOpen(true);
                          } else if (t.title === "Account Access Issue") {
                            setIssueModalOpen(true);
                          }
                        }} style={{ cursor: t.title === "New Project Verification" ? "default" : "pointer" }}>
                          <div className="card-body d-flex align-items-start justify-content-between" style={{ gap: "16px" }}>
                            <div className="d-flex align-items-center gap-3" style={{ flex: "1 1 auto", minWidth: 0, overflow: "hidden" }}>
                              {/* absolute accent (no extra width in flow) */}
                              <div className={`tk-left-accent ${t.colorClass}`} />

                              <div className="tk-task-info" style={{ flex: "1 1 auto", minWidth: 0 }}>
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center gap-2 flex-1">
                                    {section.id === 'project_verification' ? (
                                      <div
                                        className="tk-task-title"
                                        style={{ cursor: 'pointer', color: '#6366F1' }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          navigate(`/admin-projectdetails/${t.originalTask.id}`, { state: { project: t.originalTask, builderName: t.originalTask.owner_name } });
                                        }}
                                      >
                                        {t.title}
                                      </div>
                                    ) : (
                                      <div className="tk-task-title">{t.title}</div>
                                    )}
                                    {/* User type badge for Welcome Calls (matching mobile app) */}
                                    {t.userType && (section.id === 'welcome_calls' || section.id === 'missed_calls' || section.id === 'welcome_call_backlog' || section.id === 'completed_welcome_calls') && (
                                      <span
                                        className="badge"
                                        style={{
                                          backgroundColor:
                                            t.status === 'backlog' ? '#FCE7F3' :
                                              t.userType === 'builder' ? '#FFF7ED' :
                                                t.userType === 'agent' ? '#EFF6FF' :
                                                  t.userType === 'agency' ? '#F0FDF4' : '#F3F4F6',
                                          color:
                                            t.status === 'backlog' ? '#EC4899' :
                                              t.userType === 'builder' ? '#EA580C' :
                                                t.userType === 'agent' ? '#2563EB' :
                                                  t.userType === 'agency' ? '#16A34A' : '#6B7280',
                                          fontSize: '11px',
                                          fontWeight: '600',
                                          padding: '4px 8px',
                                          borderRadius: '8px'
                                        }}
                                      >
                                        {t.userType}
                                      </span>
                                    )}
                                  </div>
                                  {section.id === 'project_verification' && t.originalTask?.owner_phone && (
                                    <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0 }}>
                                      <button
                                        className="btn tk-call-btn"
                                        title="Call"
                                        style={{ flexShrink: 0, whiteSpace: "nowrap" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const project = t.originalTask;
                                          setProjectCallData({
                                            builderName: project.owner_name || project.builder_name || 'Builder',
                                            builderPhone: project.owner_phone,
                                            repName: project.owner_rep_name || 'Representative',
                                            repPhone: project.owner_rep_phone || null,
                                          });
                                          setProjectCallPickerVisible(true);
                                        }}
                                      >
                                        <span className="ms-1 tk-call-text">Call</span>
                                        {calladm && <img src={calladm} alt="call" className="tk-call-icon" />}
                                      </button>
                                    </div>
                                  )}
                                  {section.id !== 'project_verification' && section.id !== 'completed_welcome_calls' && !((section.id === 'rera_verification' || section.id === 'verification') && (t.status === 'completed' || t.status === 'cancelled')) && !(section.id === 'rera_verification' || (section.id === 'verification' && (t.originalTask?.task_type === 'rera_verification' || (t.originalTask?.title || t.title || '').toLowerCase().includes('rera')))) && !isGstTask(t.originalTask) && (
                                    <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0 }}>
                                      <button
                                        className="btn tk-call-btn"
                                        title="Call"
                                        style={{ flexShrink: 0, whiteSpace: "nowrap" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleWelcomeCall(t.originalTask);
                                        }}
                                      >
                                        <span className="ms-1 tk-call-text">Call</span>
                                        {calladm && <img src={calladm} alt="call" className="tk-call-icon" />}
                                      </button>
                                    </div>
                                  )}
                                </div>


                                {!((section.id === 'rera_verification' || section.id === 'verification') && (t.status === 'completed' || t.status === 'cancelled')) && (
                                  <div className="tk-task-sub">
                                    {t.subtitle}
                                  </div>
                                )}

                                {/* Assigned to / Unclaimed — matches app exactly */}
                                {(section.id === 'welcome_calls' || section.id === 'missed_calls' || section.id === 'welcome_call_backlog' || section.id === 'completed_welcome_calls') ? (
                                  t.originalTask?.assigned_to ? (
                                    <div style={{ fontSize: "13px", color: "#6c757d", marginTop: "4px" }}>
                                      Assigned to: <span style={{ color: "#333", fontWeight: "500" }}>{t.assigned}</span>
                                    </div>
                                  ) : (
                                    <div style={{ fontSize: "13px", color: "#D97706", fontWeight: "600", marginTop: "4px" }}>
                                      Assigning...
                                    </div>
                                  )
                                ) : (section.id === 'project_verification' || section.id === 'rera_verification' || section.id === 'verification') ? (
                                  t.originalTask?.assigned_to ? (
                                    <div style={{ fontSize: "13px", color: "#6c757d", marginTop: "4px" }}>
                                      Assigned to: <span style={{ color: "#333", fontWeight: "500" }}>{t.assigned}</span>
                                    </div>
                                  ) : (
                                    <div style={{ fontSize: "13px", color: "#D97706", fontWeight: "600", marginTop: "4px" }}>
                                      Assigning...
                                    </div>
                                  )
                                ) : (
                                  t.assigned && (
                                    <div className="tk-assigned-text" style={{ fontSize: "13px", color: "#6c757d", marginTop: "4px" }}>
                                      Assigned to: {t.assigned}
                                    </div>
                                  )
                                )}

                                {/* Accept/Decline buttons for pending Project Verification (matching mobile app) */}
                                {t.originalTask && t.originalTask.approval_status === 'pending' && section.id === 'project_verification' && (
                                  <div className="d-flex gap-2 mb-2" style={{ marginTop: "8px" }}>
                                    <button
                                      className="btn btn-sm"
                                      style={{
                                        backgroundColor: '#EF4444',
                                        color: '#fff',
                                        borderRadius: '6px',
                                        width: "300px !important",
                                        fontSize: '11px',
                                        padding: '4px 8px',
                                        border: 'none',
                                        minHeight: '28px'
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openRejectModal(t.originalTask);
                                      }}
                                      disabled={actionLoading}
                                    >
                                      ✕ Decline
                                    </button>
                                    <button
                                      className="btn btn-sm"
                                      style={{
                                        backgroundColor: '#10B981',
                                        color: '#fff',
                                        borderRadius: '6px',
                                        width: "300px !important",
                                        fontSize: '11px',
                                        padding: '4px 8px',
                                        border: 'none',
                                        minHeight: '28px'
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleApproveProject(t.originalTask);
                                      }}
                                      disabled={actionLoading}
                                    >
                                      ✓ Accept
                                    </button>
                                  </div>
                                )}


                                <div className="tk-head-border">
                                  <div className="tk-borderr"></div>
                                </div>
                                <div className="tk-time-small">

                                  <div style={{ display: "flex", alignItems: "center", gap: "6px", color: t.status === "backlog" ? "#EC4899" : "inherit" }}>
                                    <img
                                      src={adminclock}
                                      alt="time"
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                    {t.timeAgo}
                                    {/* <img
    src={adminclock}
    alt="time"
    style={{ width: "16px", height: "16px" }}
  /> */}
                                  </div>

                                  {(() => {
                                    const statusLabelMap = {
                                      'completed': 'Completed',
                                      'cancelled': 'Cancelled',
                                      'rejected': 'Rejected',
                                      'in_progress': 'In Progress',
                                      'pending': 'Pending',
                                      'backlog': 'Backlog',
                                      'on_hold': 'On Hold',
                                      'review': 'Review',
                                    };
                                    const statusColorMap = {
                                      'completed': '#27AE60',
                                      'cancelled': '#E74C3C',
                                      'rejected': '#DC2626',
                                      'in_progress': '#9B59B6',
                                      'backlog': '#EC4899',
                                    };
                                    const label = statusLabelMap[t.status];
                                    const color = statusColorMap[t.status];
                                    if (!label) return null;
                                    return (
                                      <div
                                        className={`tk-status-pill ${t.status === "Pending" ? "tk-status-pending" : ""} ${t.status === "in_progress" ? "tk-status-progress" : ""} ${t.status === "backlog" ? "tk-status-backlog" : ""}`}
                                        style={{ flexShrink: 0, whiteSpace: "nowrap", ...(color ? { backgroundColor: color, color: '#fff' } : {}) }}
                                      >
                                        {label}
                                      </div>
                                    );
                                  })()}
                                </div>

                              </div>

                            </div>


                          </div>
                        </div>
                      ))}

                      {collapsibleSections && section.items.length > (sectionVisibleCounts[section.id] || SECTION_PAGE_SIZE) && (
                        <div className="tk-load-more-row">
                          <button
                            type="button"
                            className="tk-load-more-btn"
                            onClick={() => loadMoreSection(section.id)}
                          >
                            Load More
                          </button>
                          <span className="tk-load-more-meta align-self-center">
                            Showing {sectionVisibleCounts[section.id] || SECTION_PAGE_SIZE} of {section.items.length}
                          </span>
                        </div>
                      )}
                      </div>)}
                    </div>
                  ))}

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Fixed Add Task button (edge) */}
      {/* <button className="btn btn-dark tk-fixed-add" onClick={openAddTask} title="Add Task" type="button">
        {IconAdd && <img src={IconAdd} alt="add" className="tk-icon-sm invert" />}
        <span className="ms-2">Add Task</span>
      </button> */}

      {/* FILTER MODAL */}
      {filterOpen && (
        <div className="tk-overlay" onClick={() => setFilterOpen(false)}>
          <div className="tk-modal" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Filters</h5>
              <button style={{ border: 'none', backgroundColor: "#fff" }} onClick={() => setFilterOpen(false)} ><img src={close} alt="Close" /></button>
            </div>
            <div className="tk-modal-body">
              <label className="form-label tk-label">Select Dates</label>
              <div className="d-flex gap-2 mb-3">
                <div
                  className="tk-filter-date-field"
                  onClick={() => openDatePicker("startDate")}
                  style={{ cursor: "pointer" }}
                >
                  <span>{fromDate1 || "From"}</span>
                  <img src={calendar} alt="calendar" className="tk-calendar-icon" />
                </div>
                <div
                  className="tk-filter-date-field"
                  onClick={() => openDatePicker("endDate")}
                  style={{ cursor: "pointer" }}
                >
                  <span>{toDate1 || "To"}</span>
                  <img src={calendar} alt="calendar" className="tk-calendar-icon" />
                </div>
              </div>

              <label className="form-label tk-label">Task Owner</label>
              <select className="form-select mb-3" value={filterTaskOwner} onChange={(e) => setFilterTaskOwner(e.target.value)}>
                <option value="">Select staff member</option>
                {Array.isArray(csStaffUsers) && csStaffUsers.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.name || user.email}
                  </option>
                ))}
              </select>

              <label className="form-label tk-label">Task Type</label>
              <select className="form-select mb-3" value={filterTaskType} onChange={(e) => {
                setFilterTaskType(e.target.value);
                if (e.target.value !== 'welcome_call' && filterStatus === 'missed') {
                  setFilterStatus('');
                }
              }}>
                <option value="">Select task type</option>
                <option value="welcome_call">Welcome Call</option>
                <option value="verification">Verification</option>
              </select>

              <label className="form-label tk-label">Status</label>
              <select className="form-select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                <option value="">Select status</option>
                <option value="in_progress">In Progress</option>
                <option value="completed">Completed</option>
                <option value="backlog">Backlog</option>
                <option value="rejected">Rejected</option>
                {filterTaskType === 'welcome_call' && (
                  <option value="missed">Missed</option>
                )}
              </select>
            </div>
            <div className="tk-modal-actions d-flex justify-content-between align-items-center">
              <button className="btn btn-outline-primary tk-btn-reset" onClick={resetFilters}>Reset</button>
              <button className="btn btn-primary tk-btn-apply" onClick={applyFilters}>Apply</button>
            </div>
          </div>
        </div>
      )}

      {/* ADD TASK MODAL */}
      {addOpen && (
        <div className="tk-overlay" onClick={() => setAddOpen(false)}>
          <div className="tk-modal wide" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Add Task</h5>
              <button style={{ border: 'none', backgroundColor: "#fff" }} onClick={() => setAddOpen(false)} > <img src={close} alt="Close" /></button>
            </div>

            {/* ===== UPDATED ADD TASK BODY: improved layout + date/time picker trigger ===== */}
            <div className="tk-modal-body">
              <div className="mb-3">
                <label className="form-label tk-label">Task Owner</label>
                <select className="form-select" value={taskOwner} onChange={(e) => setTaskOwner(e.target.value)}>
                  <option value="">Select Task Owner</option>
                  {adminUsers.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name || user.email}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Task Type</label>
                <select className="form-select" value={taskType} onChange={(e) => setTaskType(e.target.value)}>
                  <option value="">Select task type</option>
                  <option value="registration">Registration</option>
                  <option value="support">Support</option>
                  <option value="welcome_call">Welcome Call</option>
                  <option value="verification">Verification</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Task Name</label>
                <input className="form-control" value={taskName} onChange={(e) => setTaskName(e.target.value)} />
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Description</label>
                <textarea className="form-control" rows="3" value={description} onChange={(e) => setDescription(e.target.value)} />
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Priority</label>
                <select className="form-select" value={priority} onChange={(e) => setPriority(e.target.value)}>
                  <option value="">Select priority</option>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Task Date</label>
                <input
                  className="form-control"
                  value={fromDate}
                  placeholder="Select Date"
                  readOnly
                  onClick={() => openDatePicker("taskDate")}
                  style={{ cursor: "pointer" }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Task Status</label>
                <select className="form-select" value={status} onChange={(e) => setStatus(e.target.value)}>
                  <option value="">Select status</option>
                  <option value="todo">To Do</option>
                  <option value="pending">Pending</option>
                  <option value="in_progress">In Progress</option>
                  <option value="review">Review</option>
                  <option value="completed">Completed</option>
                  <option value="on_hold">On Hold</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
            </div>

            <div className="tk-modal-actions d-flex justify-content-end align-items-center">
              <button className=" tk-btn-apply" onClick={handleCreateTask}>ADD</button>
            </div>
          </div>
        </div>
      )}

      {/* DATE PICKER MINI-MODAL (UPDATED: visual pill style + time selection) */}
      {datePickerOpen && (
        <div className="tk-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="tk-modal small" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h6 className="mb-0">Select visit date</h6>
              <button className="btn-close" onClick={() => setDatePickerOpen(false)} />
            </div>

            <div className="tk-modal-body">
              <div className="mb-3">
                <div className="tk-picker-title">Select visit date</div>
                <div className="d-flex gap-2 mt-2 flex-wrap">
                  <button
                    className={`btn tk-date-pill ${pickerTmpDate.day === "01" ? "active" : ""}`}
                    onClick={() => setPickerTmpDate({ day: "01", month: "Jan", year: "2020" })}
                  >
                    01
                  </button>
                  <button
                    className={`btn tk-date-pill ${pickerTmpDate.day === "02" ? "active" : ""}`}
                    onClick={() => setPickerTmpDate({ day: "02", month: "Feb", year: "2021" })}
                  >
                    02
                  </button>
                  <button
                    className={`btn tk-date-pill ${pickerTmpDate.day === "03" ? "active" : ""}`}
                    onClick={() => setPickerTmpDate({ day: "03", month: "Mar", year: "2022" })}
                  >
                    03
                  </button>
                  <button
                    className={`btn tk-date-pill ${pickerTmpDate.day === "04" ? "active" : ""}`}
                    onClick={() => setPickerTmpDate({ day: "04", month: "Apr", year: "2022" })}
                  >
                    04
                  </button>
                </div>
              </div>

              <div className="mb-2">
                <div className="tk-picker-title">Select visit time</div>
                <div className="d-flex gap-2 mt-2 flex-wrap">
                  <button
                    className={`btn tk-time-pill ${pickerTmpTime.hour === "03" ? "active" : ""}`}
                    onClick={() => setPickerTmpTime({ hour: "03", minute: "00", period: "AM" })}
                  >
                    3
                  </button>
                  <button
                    className={`btn tk-time-pill ${pickerTmpTime.hour === "04" ? "active" : ""}`}
                    onClick={() => setPickerTmpTime({ hour: "04", minute: "30", period: "PM" })}
                  >
                    4
                  </button>
                  <button
                    className={`btn tk-time-pill ${pickerTmpTime.hour === "05" ? "active" : ""}`}
                    onClick={() => setPickerTmpTime({ hour: "05", minute: "00", period: "PM" })}
                  >
                    5
                  </button>
                </div>
              </div>
            </div>

            <div className="tk-modal-actions">
              <button className="btn btn-outline-secondary tk-btn-cancel" onClick={() => setDatePickerOpen(false)}>Cancel</button>
              <button
                className="btn btn-primary tk-btn-save"
                onClick={() => { applyPickerToForm(); setDatePickerOpen(false); }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Scroll Date Picker */}
      {openPicker && (
        <ScrollDatePicker
          onCancel={() => setOpenPicker(null)}
          onSave={(val) => {
            const formatted = `${val.day}-${val.month}-${val.year}`;
            if (openPicker === "task") {
              setFromDate(formatted);
            } else if (openPicker === "filterStart") {
              setFilterDates({ ...filterDates, startDate: formatted });
            } else if (openPicker === "filterEnd") {
              setFilterDates({ ...filterDates, endDate: formatted });
            }
            setOpenPicker(null);
          }}
        />
      )}

      {/* Custom Date Picker Modal */}
      {isDatePickerVisible &&
        createPortal(
          <>
            {/* 🔹 Full-page transparent dark background */}
            <div
              className="tk-datepicker-fullscreen"
              onClick={() => setIsDatePickerVisible(false)}
            ></div>

            {/* 🔹 Date picker */}
            <div className="tk-datepicker-overlay-centered">
              <div className="tk-datepicker-box">
                <div className="tk-selection-line"></div>

                {/* Day */}
                <div
                  className="tk-datepicker-col"
                  ref={dayRef}
                  onScroll={() =>
                    handleScroll(dayRef, setSelectedDayIdx, days.length)
                  }
                >
                  <div className="tk-datepicker-item tk-spacer"></div>
                  {/* Repeat days 3 times for infinite loop */}
                  {[...days, ...days, ...days].map((d, i) => (
                    <div
                      key={i}
                      className={`tk-datepicker-item ${i % days.length === selectedDayIdx ? "tk-selected" : ""
                        }`}
                    >
                      {d}
                    </div>
                  ))}
                  <div className="tk-datepicker-item tk-spacer"></div>
                </div>

                {/* Month */}
                <div
                  className="tk-datepicker-col"
                  ref={monthRef}
                  onScroll={() =>
                    handleScroll(monthRef, setSelectedMonthIdx, months.length)
                  }
                >
                  <div className="tk-datepicker-item tk-spacer"></div>
                  {/* Repeat months 3 times for infinite loop */}
                  {[...months, ...months, ...months].map((m, i) => (
                    <div
                      key={i}
                      className={`tk-datepicker-item ${i % months.length === selectedMonthIdx ? "tk-selected" : ""
                        }`}
                    >
                      {m}
                    </div>
                  ))}
                  <div className="tk-datepicker-item tk-spacer"></div>
                </div>

                {/* Year */}
                <div
                  className="tk-datepicker-col"
                  ref={yearRef}
                  onScroll={() =>
                    handleScroll(yearRef, setSelectedYearIdx, years.length)
                  }
                >
                  <div className="tk-datepicker-item tk-spacer"></div>
                  {years.map((y, i) => (
                    <div
                      key={i}
                      className={`tk-datepicker-item ${i === selectedYearIdx ? "tk-selected" : ""
                        }`}
                    >
                      {y}
                    </div>
                  ))}
                  <div className="tk-datepicker-item tk-spacer"></div>
                </div>

                <div className="tk-datepicker-actions">
                  <button
                    className="tk-cancel-btn"
                    onClick={() => setIsDatePickerVisible(false)}
                  >
                    Cancel
                  </button>
                  <button className="tk-save-btn" onClick={handleSaveDate}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </>,
          document.body // ✅ renders outside modal container
        )}

      {/* AGENT VERIFICATION MODAL */}
      {agentModalOpen && selectedTask && (
        <div className="tk-overlay" onClick={() => setAgentModalOpen(false)}>
          <div className="tk-modal small" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Verification Details</h5>
              <button style={{ border: 'none', backgroundColor: "#fff" }} onClick={() => setAgentModalOpen(false)} ><img src={close} alt="Close" /></button>
            </div>
            <div className="tk-modal-body">
              <div className="mb-2">
                <strong>Name :</strong> {selectedTask.subtitle}
                <span className="tk-status-pill tk-status-new ms-2">New</span>
              </div>
              <div className="mb-2" style={{ fontSize: "13px", color: "#6c757d" }}>
                Location : Hyderabad, Telangana
              </div>
              <div className="tk-borderr" style={{ marginBottom: "12px" }}></div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Verification Type :</strong> Agent
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Registered</strong>
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Email :</strong> <span style={{ color: "#5b6cf9" }}>michael82@gmail.com</span>
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Phone no :</strong> 9392854005
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>RERA ID :</strong> RERA2024MH001234
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Aadhar ID :</strong> 4567 8901 2345
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>PAN ID :</strong> ABCDE1234F
              </div>
              <div className="mb-3">
                <label className="form-label tk-label" style={{ fontSize: "13px", fontWeight: "bold" }}>Feedback</label>
                <textarea className="form-control" rows="3" placeholder="Enter your feedback"></textarea>
              </div>
            </div>
            <div className="tk-modal-actions d-flex justify-content-between align-items-center">
              <button className="btn btn-outline-danger" style={{ flex: 1, marginRight: "8px", borderRadius: "8px" }} onClick={() => setAgentModalOpen(false)}>Reject</button>
              <button className="btn" style={{ flex: 1, background: "linear-gradient(90deg, #9292FF 0%, #6F70FA 100%)", color: "white", borderRadius: "8px" }} onClick={() => setAgentModalOpen(false)}>Accept</button>
            </div>
          </div>
        </div>
      )}

      {/* BUILDER VERIFICATION MODAL */}
      {builderModalOpen && selectedTask && (
        <div className="tk-overlay" onClick={() => setBuilderModalOpen(false)}>
          <div className="tk-modal small" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Verification Details</h5>
              <button style={{ border: 'none', backgroundColor: "#fff" }} onClick={() => setBuilderModalOpen(false)} ><img src={close} alt="Close" /></button>
            </div>
            <div className="tk-modal-body">
              <div className="mb-2">
                <strong>Name :</strong> {selectedTask.subtitle.replace("Builder : ", "")}
                <span className="tk-status-pill tk-status-pending ms-2">Pending</span>
              </div>
              <div className="mb-2" style={{ fontSize: "13px", color: "#6c757d" }}>
                Location : Hyderabad, Telangana
              </div>
              <div className="tk-borderr" style={{ marginBottom: "12px" }}></div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Verification Type :</strong> Builder
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Registered</strong>
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Email :</strong> <span style={{ color: "#5b6cf9" }}>Skyline12@gmail.com</span>
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Phone no :</strong> 9393893305
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Tan no :</strong> 7890 1234 5678
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>PAN ID :</strong> FGHIJ5678K
              </div>
              <div className="mb-3">
                <label className="form-label tk-label" style={{ fontSize: "13px", fontWeight: "bold" }}>Feedback</label>
                <textarea className="form-control" rows="3" placeholder="Enter your feedback"></textarea>
              </div>
            </div>
            <div className="tk-modal-actions d-flex justify-content-between align-items-center">
              <button className="btn btn-outline-danger" style={{ flex: 1, marginRight: "8px", borderRadius: "8px" }} onClick={() => setBuilderModalOpen(false)}>Reject</button>
              <button className="btn" style={{ flex: 1, background: "linear-gradient(90deg, #9292FF 0%, #6F70FA 100%)", color: "white", borderRadius: "8px" }} onClick={() => setBuilderModalOpen(false)}>Accept</button>
            </div>
          </div>
        </div>
      )}

      {/* ACCOUNT ACCESS ISSUE MODAL */}
      {issueModalOpen && selectedTask && (
        <div className="tk-overlay" onClick={() => setIssueModalOpen(false)}>
          <div className="tk-modal small" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Account Access Issue</h5>
              <button style={{ border: 'none', backgroundColor: "#fff" }} onClick={() => setIssueModalOpen(false)} ><img src={close} alt="Close" /></button>
            </div>
            <div className="tk-modal-body">
              <div className="mb-2" style={{ fontSize: "12px", fontWeight: "500" }}>
                <strong>Reported By :</strong> {selectedTask.subtitle}
                <span className="tk-status-pill tk-status-progress ms-2">In Progress</span>
              </div>
              <div className="mb-2" style={{ fontSize: "13px", color: "#6c757d" }}>
                Location : Hyderabad, Telangana
              </div>
              <div className="tk-borderr" style={{ marginBottom: "12px" }}></div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Reported Time :</strong> 30 minutes ago
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Issue :</strong> The builder is unable to log into their account due to repeated credential mismatch errors.
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Email :</strong> <span style={{ color: "#5b6cf9" }}>Skyline12@gmail.com</span>
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <strong>Phone no :</strong> 9393893305
              </div>
              <div className="mb-3">
                <label className="form-label tk-label" style={{ fontSize: "13px", fontWeight: "bold" }}>Feedback</label>
                <textarea className="form-control" rows="3" placeholder="Enter your feedback"></textarea>
              </div>
            </div>
            <div className="tk-modal-actions d-flex justify-content-between align-items-center">
              <button className="btn btn-outline-danger" style={{ flex: 1, marginRight: "8px", borderRadius: "8px" }} onClick={() => setIssueModalOpen(false)}>Backlog</button>
              <button className="btn" style={{ flex: 1, background: "linear-gradient(90deg, #9292FF 0%, #6F70FA 100%)", color: "white", borderRadius: "8px" }} onClick={() => setIssueModalOpen(false)}>Resolve</button>
            </div>
          </div>
        </div>
      )}

      {/* EDIT TASK MODAL (matching React Native app) */}
      {editModalVisible && (
        <div className="tk-overlay" onClick={() => setEditModalVisible(false)}>
          <div className="tk-modal wide" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Edit Task</h5>
              <button style={{ border: 'none', backgroundColor: "#fff" }} onClick={() => setEditModalVisible(false)}>
                <img src={close} alt="Close" />
              </button>
            </div>

            <div className="tk-modal-body">
              <div className="mb-3">
                <label className="form-label tk-label">Task Owner</label>
                <select className="form-select" value={editAssignedTo} onChange={(e) => setEditAssignedTo(e.target.value)}>
                  <option value="">Select Task Owner</option>
                  {adminUsers.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name || user.email}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Task Type</label>
                <select className="form-select" value={editTaskType} onChange={(e) => setEditTaskType(e.target.value)}>
                  <option value="">Select task type</option>
                  <option value="registration">Registration</option>
                  <option value="support">Support</option>
                  <option value="welcome_call">Welcome Call</option>
                  <option value="verification">Verification</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Task Name</label>
                <input className="form-control" value={editTaskName} onChange={(e) => setEditTaskName(e.target.value)} />
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Description</label>
                <textarea className="form-control" rows="3" value={editDescription} onChange={(e) => setEditDescription(e.target.value)} />
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Priority</label>
                <select className="form-select" value={editPriority} onChange={(e) => setEditPriority(e.target.value)}>
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Task Date</label>
                <input
                  className="form-control"
                  value={editDueDate}
                  placeholder="Select Date"
                  readOnly
                  onClick={() => openDatePicker("taskDate")}
                  style={{ cursor: "pointer" }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Task Status</label>
                <select className="form-select" value={editStatus} onChange={(e) => setEditStatus(e.target.value)}>
                  <option value="todo">To Do</option>
                  <option value="pending">Pending</option>
                  <option value="in_progress">In Progress</option>
                  <option value="review">Review</option>
                  <option value="completed">Completed</option>
                  <option value="on_hold">On Hold</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
            </div>

            <div className="tk-modal-actions d-flex justify-content-between align-items-center">
              <button className="btn btn-outline-secondary" onClick={() => setEditModalVisible(false)}>Cancel</button>
              <button className="tk-btn-apply" onClick={handleUpdateTask} disabled={loading}>
                {loading ? 'Updating...' : 'Update Task'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PROJECT REJECTION MODAL (matching mobile app) */}
      {rejectModalVisible && (
        <div className="tk-overlay" onClick={() => setRejectModalVisible(false)}>
          <div className="tk-modal" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Decline Project</h5>
              <button style={{ border: 'none', backgroundColor: "#fff" }} onClick={() => setRejectModalVisible(false)}>
                <img src={close} alt="Close" />
              </button>
            </div>

            <div className="tk-modal-body">
              <div className="mb-3">
                <label className="form-label tk-label">Project Name</label>
                <input
                  className="form-control"
                  value={selectedProject?.property_title || selectedProject?.title || ''}
                  readOnly
                  style={{ backgroundColor: '#f8f9fa' }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label tk-label">Rejection Reason <span style={{ color: 'red' }}>*</span></label>
                <textarea
                  className="form-control"
                  rows="4"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  placeholder="Please provide a reason for declining this project..."
                />
              </div>
            </div>

            <div className="tk-modal-actions d-flex justify-content-between align-items-center">
              <button className="btn btn-outline-secondary" onClick={() => setRejectModalVisible(false)} disabled={actionLoading}>
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={handleRejectProject}
                disabled={actionLoading || !rejectionReason.trim()}
                style={{ backgroundColor: '#EF4444', borderColor: '#EF4444' }}
              >
                {actionLoading ? 'Declining...' : 'Decline Project'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* WELCOME CALL FEEDBACK MODAL (matching mobile app) */}
      {feedbackModalVisible && (
        <div className="tk-overlay" onClick={() => { }}>
          <div className="tk-modal wide" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Call Feedback</h5>
              {/* No close button - must complete or cancel like mobile app */}
            </div>



            <div className="tk-modal-body">
              {/* User Info Display */}
              {currentCallTask && (
                <div style={{ backgroundColor: '#F9FAFB', borderRadius: '10px', padding: '14px', marginBottom: '14px' }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 style={{ fontSize: '16px', fontWeight: '700', color: '#111', margin: 0 }}>
                      {currentCallTask.target_user_name || 'Unknown User'}
                    </h6>
                    <span
                      className="badge"
                      style={{
                        backgroundColor:
                          currentCallTask.target_user_type === 'builder' ? '#FFF7ED' :
                            currentCallTask.target_user_type === 'agent' ? '#EFF6FF' :
                              currentCallTask.target_user_type === 'agency' ? '#F0FDF4' : '#F3F4F6',
                        color:
                          currentCallTask.target_user_type === 'builder' ? '#EA580C' :
                            currentCallTask.target_user_type === 'agent' ? '#2563EB' :
                              currentCallTask.target_user_type === 'agency' ? '#16A34A' : '#6B7280',
                        fontSize: '11px',
                        fontWeight: '600'
                      }}
                    >
                      {currentCallTask.target_user_type || 'user'}
                    </span>
                  </div>
                  <p style={{ color: '#555', fontSize: '13px', margin: 0 }}>
                    Phone: {currentCallTask.target_user_phone || 'N/A'}
                  </p>
                </div>
              )}

              {/* Feedback Input */}
              <div className="mb-3">
                <label className="form-label tk-label">Feedback <span style={{ color: 'red' }}>*</span></label>
                <textarea
                  className="form-control"
                  rows="5"
                  value={feedbackText}
                  onChange={(e) => setFeedbackText(e.target.value)}
                  placeholder="Enter your call feedback..."
                />
              </div>
            </div>
            {/* Add Follow-up Task Button at top */}
            <div style={{ padding: '20px 20px 0 20px' }}>
              <button
                className="btn btn-outline-primary"
                onClick={handleOpenScheduleModal}
                style={{
                  width: '100%',
                  marginBottom: '16px',
                  borderColor: '#6366F1',
                  color: '#6366F1',
                  backgroundColor: '#F9FAFB'
                }}
              >
                + Add Follow-up Task
              </button>
            </div>
            <div className="tk-modal-actions">
              {/* Cancel and Complete Task buttons at bottom */}
              <div className="d-flex justify-content-between align-items-center">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    setFeedbackModalVisible(false);
                    setFeedbackText('');
                    setCurrentCallTask(null);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleCompleteWelcomeTask}
                  disabled={!feedbackText.trim() || welcomeLoading}
                  style={{ backgroundColor: feedbackText.trim() ? '#6366F1' : '#D1D5DB' }}
                >
                  {welcomeLoading ? 'Completing...' : 'Complete Task'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SCHEDULE FOLLOW-UP TASK MODAL (matching mobile app) */}
      {scheduleModalVisible && (
        <div className="tk-overlay" onClick={() => setScheduleModalVisible(false)}>
          <div className="tk-modal wide" onClick={(e) => e.stopPropagation()}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Schedule Follow-up</h5>
              <button style={{ border: 'none', backgroundColor: "#fff" }} onClick={() => setScheduleModalVisible(false)}>
                <img src={close} alt="Close" />
              </button>
            </div>

            <div className="tk-modal-body">
              {/* Task Name */}
              <div className="mb-3">
                <label className="form-label tk-label">Task Name <span style={{ color: 'red' }}>*</span></label>
                <input
                  className="form-control"
                  placeholder="Enter task name"
                  value={scheduleTaskName}
                  onChange={(e) => setScheduleTaskName(e.target.value)}
                />
              </div>

              {/* User Type and Name - Pre-filled from current call task */}
              {currentCallTask && (
                <>
                  <div className="mb-3">
                    <label className="form-label tk-label">User Type</label>
                    <input
                      className="form-control"
                      value={currentCallTask.target_user_type || 'N/A'}
                      readOnly
                      style={{ backgroundColor: '#F9FAFB' }}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label tk-label">Name</label>
                    <input
                      className="form-control"
                      value={currentCallTask.target_user_name || 'N/A'}
                      readOnly
                      style={{ backgroundColor: '#F9FAFB' }}
                    />
                  </div>
                </>
              )}

              {/* Assigned To - shows CS staff with availability status (matching mobile app) */}
              <div className="mb-3">
                <label className="form-label tk-label">Assigned To</label>
                <select className="form-select" value={scheduleAssignedTo} onChange={(e) => setScheduleAssignedTo(e.target.value)}>
                  <option value="">Select staff to assign</option>
                  {freeStaff.map((staff) => {
                    const availLabel = staff.is_online
                      ? (staff.status === 'free' ? 'Free' : 'Busy')
                      : 'Offline';
                    return (
                      <option
                        key={staff.staff_id || staff.id}
                        value={staff.staff_id || staff.id}
                        style={{ color: staff.is_online && staff.status === 'free' ? '#2E7D32' : '#999' }}
                      >
                        {`${staff.name || staff.email} (${availLabel})`}
                      </option>
                    );
                  })}
                </select>
              </div>

              {/* Schedule Date & Time */}
              <div className="mb-3">
                <label className="form-label tk-label">Schedule Date & Time <span style={{ color: 'red' }}>*</span></label>
                <div className="d-flex gap-2">
                  <input
                    type="date"
                    className="form-control"
                    value={scheduleDate}
                    onChange={(e) => setScheduleDate(e.target.value)}
                  />
                  <input
                    type="time"
                    className="form-control"
                    value={scheduleTime}
                    onChange={(e) => setScheduleTime(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="tk-modal-actions d-flex justify-content-between align-items-center">
              <button className="btn btn-outline-secondary" onClick={() => setScheduleModalVisible(false)}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleCreateScheduledTask}
                disabled={!scheduleTaskName.trim() || !scheduleDate || welcomeLoading}
              >
                {welcomeLoading ? 'Creating...' : 'Add Task'}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* RERA VERIFICATION MODAL (matching mobile app exactly) */}
      {reraModalVisible && (
        <div className="tk-overlay" onClick={() => { setReraModalVisible(false); setReraRejectReason(''); }}>
          <div className="tk-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '480px' }}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0" style={{ fontSize: '18px', fontWeight: '700', color: '#1E1E1E' }}>RERA Verification</h5>
              <button style={{ border: 'none', backgroundColor: '#fff' }} onClick={() => { setReraModalVisible(false); setReraRejectReason(''); }}>
                <img src={close} alt="Close" />
              </button>
            </div>

            {reraModalTask && (() => {
                const taskFullTitle = reraModalTask.task_title || reraModalTask.title || '';
                const dashIdx = taskFullTitle.indexOf(' - ');
                const parsedName = dashIdx !== -1 ? taskFullTitle.slice(dashIdx + 3) : null;

                const descLines = (reraModalTask.description || '').split('\n');
                const roleLine = descLines.find(l => l.toLowerCase().startsWith('role:'));
                const parsedRole = roleLine ? roleLine.split(':')[1]?.trim().toLowerCase() : null;
                const userType = reraModalTask.related_to_type || reraModalTask.target_user_type || parsedRole || 'agent';
                const displayName = reraModalTask.related_to_name || reraModalTask.target_user_name || parsedName;

                return (
              <div className="tk-modal-body">
                {/* Task details card */}
                <div style={{ backgroundColor: '#F8F9FC', borderRadius: '10px', padding: '14px', marginBottom: '16px' }}>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                    {displayName ? (
                      <>
                        {'RERA Verification - '}
                        <span
                          onClick={() => {
                            const userId = reraModalTask.related_to_id;
                            setReraModalVisible(false);
                            if (userType === 'agency') {
                              navigate('/AdminAgencyProfile', { state: { agencyId: userId } });
                            } else {
                              navigate('/AdminAgentProfile', { state: { agentId: userId } });
                            }
                          }}
                          style={{ color: '#6366F1', cursor: 'pointer', textDecoration: 'underline' }}
                        >
                          {displayName}
                        </span>
                      </>
                    ) : taskFullTitle}
                  </div>
                  {descLines.map((line, i) => (
                    <div key={i} style={{ fontSize: '13px', color: '#555', lineHeight: '22px' }}>{line}</div>
                  ))}
                </div>

                <div className="mb-3">
                  <label className="form-label tk-label" style={{ fontSize: '13px', fontWeight: '600', color: '#333' }}>
                    Rejection Reason <span style={{ color: 'red' }}>*</span> (required if rejecting)
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={reraRejectReason}
                    onChange={(e) => setReraRejectReason(e.target.value)}
                    placeholder="Enter reason for rejection..."
                    style={{ fontSize: '13px' }}
                  />
                </div>

                <div className="d-flex gap-3">
                  <button
                    className="btn flex-fill"
                    style={{ backgroundColor: '#DC2626', color: '#fff', borderRadius: '10px', fontWeight: '600', fontSize: '14px' }}
                    onClick={() => handleReraVerification('rejected')}
                    disabled={reraProcessing}
                  >
                    {reraProcessing ? 'Processing...' : 'Reject'}
                  </button>
                  <button
                    className="btn flex-fill"
                    style={{ backgroundColor: '#16A34A', color: '#fff', borderRadius: '10px', fontWeight: '600', fontSize: '14px' }}
                    onClick={() => handleReraVerification('verified')}
                    disabled={reraProcessing}
                  >
                    {reraProcessing ? 'Processing...' : 'Mark as Verified'}
                  </button>
                </div>
              </div>
                );
              })()}
          </div>
        </div>
      )}
      {/* GST VERIFICATION MODAL */}
      {gstModalVisible && (
        <div className="tk-overlay" onClick={() => { setGstModalVisible(false); setGstRejectReason(''); }}>
          <div className="tk-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '480px' }}>
            <div className="tk-modal-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0" style={{ fontSize: '18px', fontWeight: '700', color: '#1E1E1E' }}>GST Verification</h5>
              <button style={{ border: 'none', backgroundColor: '#fff' }} onClick={() => { setGstModalVisible(false); setGstRejectReason(''); }}>
                <img src={close} alt="Close" />
              </button>
            </div>

            {gstModalTask && (
              <div className="tk-modal-body">
                {/* Task details card */}
                <div style={{ backgroundColor: '#F8F9FC', borderRadius: '10px', padding: '14px', marginBottom: '16px' }}>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                    {gstModalTask.task_title || gstModalTask.title || 'GST Verification'}
                  </div>
                  {(gstModalTask.description || '').split('\n').map((line, i) => (
                    <div key={i} style={{ fontSize: '13px', color: '#555', lineHeight: '22px' }}>{line}</div>
                  ))}
                </div>

                <div className="mb-3">
                  <label className="form-label tk-label" style={{ fontSize: '13px', fontWeight: '600', color: '#333' }}>
                    Rejection Reason (required if rejecting)
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={gstRejectReason}
                    onChange={(e) => setGstRejectReason(e.target.value)}
                    placeholder="Enter reason for rejection..."
                    style={{ fontSize: '13px' }}
                  />
                </div>

                <div className="d-flex gap-3">
                  <button
                    className="btn flex-fill"
                    style={{ backgroundColor: '#DC2626', color: '#fff', borderRadius: '10px', fontWeight: '600', fontSize: '14px' }}
                    onClick={() => handleGstVerification('rejected')}
                    disabled={gstProcessing}
                  >
                    {gstProcessing ? 'Processing...' : 'Reject'}
                  </button>
                  <button
                    className="btn flex-fill"
                    style={{ backgroundColor: '#16A34A', color: '#fff', borderRadius: '10px', fontWeight: '600', fontSize: '14px' }}
                    onClick={() => handleGstVerification('verified')}
                    disabled={gstProcessing}
                  >
                    {gstProcessing ? 'Processing...' : 'Mark as Verified'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* SELECT WHO TO CALL MODAL (matching AdminTask.js mobile flow) */}
      {phonePickerVisible && pendingCallTask && (
        <div className="tk-overlay" onClick={() => setPhonePickerVisible(false)}>
          <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: '#fff', borderRadius: '20px', padding: '24px', width: '100%', maxWidth: '340px', margin: 'auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '4px' }}>Select who to call</div>
              <div style={{ fontSize: '13px', color: '#9CA3AF' }}>
                {pendingCallTask.target_user_type === 'builder' ? 'Builder' : 'Agency'} contact options
              </div>
            </div>

            {/* User (Agency/Builder) option */}
            <div
              onClick={() => handlePhoneSelect(pendingCallTask.target_user_phone)}
              style={{ display: 'flex', alignItems: 'center', backgroundColor: '#F0FDF4', borderRadius: '14px', padding: '14px', marginBottom: '10px', border: '1px solid #BBF7D0', cursor: 'pointer' }}
            >
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#059669', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px', flexShrink: 0 }}>
                <span style={{ color: '#fff', fontSize: '18px' }}>🏢</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {pendingCallTask.target_user_name || (pendingCallTask.target_user_type === 'builder' ? 'Builder' : 'Agency')}
                </div>
                <div style={{ fontSize: '13px', color: '#6B7280', marginTop: '2px' }}>{pendingCallTask.target_user_phone || 'N/A'}</div>
              </div>
              <span style={{ color: '#059669', fontSize: '18px' }}>📞</span>
            </div>

            {/* Representative option */}
            <div
              onClick={() => handlePhoneSelect(pendingCallTask.rep_phone)}
              style={{ display: 'flex', alignItems: 'center', backgroundColor: '#EFF6FF', borderRadius: '14px', padding: '14px', marginBottom: '16px', border: '1px solid #BFDBFE', cursor: 'pointer' }}
            >
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#2563EB', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px', flexShrink: 0 }}>
                <span style={{ color: '#fff', fontSize: '18px' }}>👤</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {pendingCallTask.rep_name || 'Representative'}
                </div>
                <div style={{ fontSize: '13px', color: '#6B7280', marginTop: '2px' }}>{pendingCallTask.rep_phone || 'N/A'}</div>
              </div>
              <span style={{ color: '#2563EB', fontSize: '18px' }}>📞</span>
            </div>

            {/* Cancel */}
            <div
              onClick={() => setPhonePickerVisible(false)}
              style={{ textAlign: 'center', paddingTop: '4px', cursor: 'pointer' }}
            >
              <span style={{ fontSize: '15px', fontWeight: '600', color: '#6B7280' }}>Cancel</span>
            </div>
          </div>
        </div>
      )}

      {/* PROJECT CALL PICKER MODAL (matching mobile app exactly) */}
      {projectCallPickerVisible && (
        <div className="tk-overlay" onClick={() => setProjectCallPickerVisible(false)}>
          <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: '#fff', borderRadius: '20px', padding: '24px', width: '100%', maxWidth: '360px', margin: 'auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '4px' }}>Select who to call</div>
              <div style={{ fontSize: '13px', color: '#9CA3AF' }}>Builder contact options</div>
            </div>

            {/* Builder option */}
            <div
              onClick={() => { setProjectCallPickerVisible(false); window.open(`tel:${projectCallData?.builderPhone}`, '_self'); }}
              style={{ display: 'flex', alignItems: 'center', backgroundColor: '#F0FDF4', borderRadius: '14px', padding: '14px', marginBottom: '10px', border: '1px solid #BBF7D0', cursor: 'pointer' }}
            >
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#059669', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px', flexShrink: 0 }}>
                <span style={{ color: '#fff', fontSize: '18px' }}>🏢</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{projectCallData?.builderName || 'Builder'}</div>
                <div style={{ fontSize: '13px', color: '#6B7280', marginTop: '2px' }}>{projectCallData?.builderPhone || 'N/A'}</div>
              </div>
              <span style={{ color: '#059669', fontSize: '18px' }}>📞</span>
            </div>

            {/* Representative option */}
            {projectCallData?.repPhone && (
              <div
                onClick={() => { setProjectCallPickerVisible(false); window.open(`tel:${projectCallData?.repPhone}`); }}
                style={{ display: 'flex', alignItems: 'center', backgroundColor: '#EFF6FF', borderRadius: '14px', padding: '14px', marginBottom: '16px', border: '1px solid #BFDBFE', cursor: 'pointer' }}
              >
                <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#2563EB', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px', flexShrink: 0 }}>
                  <span style={{ color: '#fff', fontSize: '18px' }}>👤</span>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{projectCallData?.repName || 'Representative'}</div>
                  <div style={{ fontSize: '13px', color: '#6B7280', marginTop: '2px' }}>{projectCallData?.repPhone || 'N/A'}</div>
                </div>
                <span style={{ color: '#2563EB', fontSize: '18px' }}>📞</span>
              </div>
            )}

            {/* Cancel */}
            <div
              onClick={() => setProjectCallPickerVisible(false)}
              style={{ textAlign: 'center', paddingTop: '4px', cursor: 'pointer' }}
            >
              <span style={{ fontSize: '15px', fontWeight: '600', color: '#6B7280' }}>Cancel</span>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
